package com.evoapps.evoshift.ui.workplaces
import androidx.compose.ui.platform.testTag
import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.ui.util.label
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.material3.SwitchDefaults
import androidx.compose.material3.Switch

import androidx.compose.material.icons.filled.Edit

import androidx.compose.material.icons.filled.EventNote

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.compose.material.icons.filled.Bedtime
import androidx.compose.material.icons.filled.Campaign
import androidx.compose.material.icons.filled.WbSunny
import androidx.compose.material.icons.filled.VisibilityOff
import com.evoapps.evoshift.domain.model.RosterVisibility
import evoshift.composeapp.generated.resources.settings_roster_visibility
import evoshift.composeapp.generated.resources.settings_roster_visibility_full
import evoshift.composeapp.generated.resources.settings_roster_visibility_full_desc
import evoshift.composeapp.generated.resources.settings_roster_visibility_hidden_people
import evoshift.composeapp.generated.resources.settings_roster_visibility_hint
import evoshift.composeapp.generated.resources.settings_roster_visibility_own
import evoshift.composeapp.generated.resources.settings_roster_visibility_own_desc
import evoshift.composeapp.generated.resources.settings_roster_visibility_title
import evoshift.composeapp.generated.resources.settings_roster_visibility_with_me
import evoshift.composeapp.generated.resources.settings_roster_visibility_with_me_desc
import evoshift.composeapp.generated.resources.settings_rest_rules_title
import evoshift.composeapp.generated.resources.settings_weather
import evoshift.composeapp.generated.resources.settings_footer
import evoshift.composeapp.generated.resources.settings_footer_hint
import evoshift.composeapp.generated.resources.settings_footer_off
import evoshift.composeapp.generated.resources.settings_footer_on
import evoshift.composeapp.generated.resources.settings_footer_paid_only
import evoshift.composeapp.generated.resources.settings_footer_switch
import evoshift.composeapp.generated.resources.settings_footer_title
import evoshift.composeapp.generated.resources.settings_weather_hint
import evoshift.composeapp.generated.resources.settings_weather_needs_location
import evoshift.composeapp.generated.resources.settings_weather_off
import evoshift.composeapp.generated.resources.settings_weather_on
import evoshift.composeapp.generated.resources.settings_weather_sources
import evoshift.composeapp.generated.resources.settings_weather_switch
import evoshift.composeapp.generated.resources.settings_weather_title
import evoshift.composeapp.generated.resources.settings_special_days_title
import evoshift.composeapp.generated.resources.settings_special_days
import evoshift.composeapp.generated.resources.settings_special_days_on
import evoshift.composeapp.generated.resources.settings_special_days_off
import evoshift.composeapp.generated.resources.settings_special_days_switch
import evoshift.composeapp.generated.resources.settings_special_days_hint
import evoshift.composeapp.generated.resources.settings_special_days_voivodeship
import evoshift.composeapp.generated.resources.settings_special_days_voivodeship_auto
import evoshift.composeapp.generated.resources.settings_special_days_voivodeship_found
import evoshift.composeapp.generated.resources.settings_special_days_voivodeship_unknown
import evoshift.composeapp.generated.resources.settings_special_days_sources
import androidx.compose.material.icons.filled.Weekend
import com.evoapps.evoshift.widgets.EvoDropdown
import androidx.compose.ui.platform.testTag
import evoshift.composeapp.generated.resources.settings_rest_rules
import evoshift.composeapp.generated.resources.settings_rest_rules_switch
import evoshift.composeapp.generated.resources.settings_rest_rules_on
import evoshift.composeapp.generated.resources.settings_rest_rules_off
import evoshift.composeapp.generated.resources.settings_rest_rules_hint
import androidx.compose.material.icons.filled.FactCheck
import com.evoapps.evoshift.domain.model.ClockReviewSettings
import evoshift.composeapp.generated.resources.settings_clock_review_explained
import evoshift.composeapp.generated.resources.settings_edit_clock_review
import evoshift.composeapp.generated.resources.settings_clock_seconds
import evoshift.composeapp.generated.resources.settings_clock_minutes
import evoshift.composeapp.generated.resources.settings_clock_off
import evoshift.composeapp.generated.resources.settings_clock_photo_explained
import evoshift.composeapp.generated.resources.settings_clock_photo
import evoshift.composeapp.generated.resources.settings_clock_no_app_explained
import evoshift.composeapp.generated.resources.settings_clock_no_app
import evoshift.composeapp.generated.resources.settings_clock_same_tablet
import evoshift.composeapp.generated.resources.settings_clock_qr_only_explained
import evoshift.composeapp.generated.resources.settings_clock_qr_only
import evoshift.composeapp.generated.resources.settings_clock_count_from_plan_explained
import evoshift.composeapp.generated.resources.settings_clock_count_from_plan
import evoshift.composeapp.generated.resources.settings_clock_very_short
import evoshift.composeapp.generated.resources.settings_clock_overrun
import evoshift.composeapp.generated.resources.settings_clock_late_out
import evoshift.composeapp.generated.resources.settings_clock_early_in
import evoshift.composeapp.generated.resources.settings_help_clock_review
import evoshift.composeapp.generated.resources.settings_clock_review
import com.evoapps.evoshift.domain.model.BreakPolicy
import androidx.compose.material.icons.filled.FreeBreakfast
import com.evoapps.evoshift.domain.model.GeofenceMode
import androidx.compose.material.icons.filled.MyLocation
import evoshift.composeapp.generated.resources.labour_budget
import evoshift.composeapp.generated.resources.settings_help_labour_budget
import evoshift.composeapp.generated.resources.settings_labour_budget_monthly
import evoshift.composeapp.generated.resources.settings_labour_budget_off
import evoshift.composeapp.generated.resources.settings_labour_budget_weekly
import evoshift.composeapp.generated.resources.settings_labour_budget_invalid
import evoshift.composeapp.generated.resources.settings_edit_labour_budget
import evoshift.composeapp.generated.resources.settings_labour_budget_enable
import evoshift.composeapp.generated.resources.settings_labour_budget_hint
import evoshift.composeapp.generated.resources.settings_labour_budget_weekly_hint
import androidx.compose.material.icons.filled.AccountBalanceWallet
import com.evoapps.evoshift.domain.budget.LabourBudget
import evoshift.composeapp.generated.resources.settings_geofence
import evoshift.composeapp.generated.resources.settings_geofence_check
import evoshift.composeapp.generated.resources.settings_geofence_meters
import evoshift.composeapp.generated.resources.settings_geofence_radius
import evoshift.composeapp.generated.resources.settings_help_geofence
import androidx.compose.material.icons.filled.HealthAndSafety
import evoshift.composeapp.generated.resources.settings_block_expired
import evoshift.composeapp.generated.resources.settings_block_expired_hint
import evoshift.composeapp.generated.resources.settings_block_expired_off
import evoshift.composeapp.generated.resources.settings_block_expired_on
import evoshift.composeapp.generated.resources.settings_block_expired_switch
import evoshift.composeapp.generated.resources.staff_checks_title
import com.evoapps.evoshift.widgets.EvoSwitchRow
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.adaptive.ScrollingRow
import com.evoapps.evoshift.ui.notifications.notificationsAction
import com.evoapps.evoshift.ui.legal.DataExportEntry
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.ui.finance.formatPercent
import com.evoapps.evoshift.ui.finance.formatMoney
import kotlinx.datetime.DayOfWeek
import com.evoapps.evoshift.viewmodels.Gate
import com.evoapps.evoshift.viewmodels.shows
import com.evoapps.evoshift.widgets.formatEditable
import com.evoapps.evoshift.ui.LightGold
import evoshift.composeapp.generated.resources.settings_edit_payroll
import evoshift.composeapp.generated.resources.settings_help_general
import evoshift.composeapp.generated.resources.settings_help_financials
import evoshift.composeapp.generated.resources.settings_help_payroll
import evoshift.composeapp.generated.resources.settings_help_staff_skills
import evoshift.composeapp.generated.resources.settings_lead_mark_role
import evoshift.composeapp.generated.resources.settings_lead_mark_skill
import evoshift.composeapp.generated.resources.settings_lead_marks
import evoshift.composeapp.generated.resources.settings_lead_marks_hint
import evoshift.composeapp.generated.resources.settings_help_availability_slots
import evoshift.composeapp.generated.resources.settings_help_sales_targets
import evoshift.composeapp.generated.resources.settings_help_roster_blueprint
import evoshift.composeapp.generated.resources.settings_night_hint
import evoshift.composeapp.generated.resources.settings_night_end
import evoshift.composeapp.generated.resources.settings_night_start
import evoshift.composeapp.generated.resources.settings_owner_unpaid
import evoshift.composeapp.generated.resources.settings_time_off_in_lieu_hint
import evoshift.composeapp.generated.resources.settings_time_off_in_lieu
import evoshift.composeapp.generated.resources.settings_settlement_period_hint
import evoshift.composeapp.generated.resources.settings_settlement_months_4
import evoshift.composeapp.generated.resources.settings_settlement_months_3
import evoshift.composeapp.generated.resources.settings_settlement_months_2
import evoshift.composeapp.generated.resources.settings_settlement_months_1
import evoshift.composeapp.generated.resources.settings_settlement_period
import evoshift.composeapp.generated.resources.settings_owner_unpaid_hint
import evoshift.composeapp.generated.resources.settings_night_period
import evoshift.composeapp.generated.resources.settings_no_show
import evoshift.composeapp.generated.resources.settings_checklist_alert
import evoshift.composeapp.generated.resources.settings_checklist_alert_after
import evoshift.composeapp.generated.resources.settings_checklist_alert_desc
import evoshift.composeapp.generated.resources.settings_no_show_after
import evoshift.composeapp.generated.resources.settings_no_show_desc
import evoshift.composeapp.generated.resources.settings_no_show_minutes
import evoshift.composeapp.generated.resources.settings_no_show_off
import com.evoapps.evoshift.domain.model.WorkplaceSettings
import androidx.compose.material.icons.filled.PersonOff
import androidx.compose.material.icons.filled.Checklist
import evoshift.composeapp.generated.resources.settings_accident_rate_hint
import evoshift.composeapp.generated.resources.settings_accident_rate
import evoshift.composeapp.generated.resources.market_poland
import evoshift.composeapp.generated.resources.settings_market
import evoshift.composeapp.generated.resources.settings_payroll
import androidx.compose.material.icons.filled.AccountBalance
import com.evoapps.evoshift.ui.finance.formatDecimal
import com.evoapps.evoshift.domain.market.payroll.WorkplacePayrollSettings
import com.evoapps.evoshift.domain.market.payroll.OpenShiftCostMode
import com.evoapps.evoshift.domain.market.payroll.OpenShiftCostSetting
import com.evoapps.evoshift.ui.finance.formatSpmhOrDash
import com.evoapps.evoshift.domain.market.Market
import com.evoapps.evoshift.domain.model.LabourShare
import com.evoapps.evoshift.domain.staffing.LabourTarget
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.ContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.ResponsiveColumns
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.handCursor
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.tween
import androidx.compose.animation.expandVertically
import androidx.compose.animation.shrinkVertically
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.TrendingUp
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Business
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.EditCalendar
import androidx.compose.material.icons.filled.Event
import androidx.compose.material.icons.filled.ExpandLess
import androidx.compose.material.icons.filled.ExpandMore
import androidx.compose.material.icons.filled.Groups
import androidx.compose.material.icons.filled.Schedule
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CenterAlignedTopAppBar
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.AvailabilitySlot
import com.evoapps.evoshift.domain.model.SwapPolicy
import com.evoapps.evoshift.domain.model.SundayPolicy
import com.evoapps.evoshift.ui.util.sundayPolicyDescriptionRes
import com.evoapps.evoshift.ui.util.sundayPolicyTitleRes
import com.evoapps.evoshift.domain.model.WorkplaceFinancials
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.GoldMetallicBrush
import com.evoapps.evoshift.viewmodels.SettingsEvent
import com.evoapps.evoshift.viewmodels.WorkplaceSettingsViewModel
import com.evoapps.evoshift.widgets.RegularCard
import androidx.compose.foundation.border
import androidx.compose.material.icons.filled.Map
import androidx.compose.material.icons.filled.Place
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardCapitalization
import com.evoapps.evoshift.ui.adaptive.WindowWidthClass
import com.evoapps.evoshift.widgets.DataRow
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.DialogSection
import com.evoapps.evoshift.widgets.DialogSectionLabel
import com.evoapps.evoshift.widgets.ErrorOnNavy
import com.evoapps.evoshift.widgets.EvoCheckboxRow
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoPrimaryButton
import com.evoapps.evoshift.widgets.EvoRadioGroup
import com.evoapps.evoshift.widgets.EvoSecondaryButton
import com.evoapps.evoshift.widgets.EvoSegmented
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.EvoTimeField
import com.evoapps.evoshift.widgets.ProfileSection
import com.evoapps.evoshift.widgets.parseClockTime
import com.evoapps.evoshift.widgets.parseDecimal
import com.evoapps.evoshift.widgets.StringListEditor
import evoshift.composeapp.generated.resources.*
import org.jetbrains.compose.resources.stringResource
import com.evoapps.evoshift.domain.util.AppClock.now

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun WorkplaceSettingsScreen(
    viewModel: WorkplaceSettingsViewModel,
    onNavigateBack: () -> Unit,
    onNavigateToTemplateEditor: () -> Unit
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }

    // Dialog Visibility States
    var showGeneralEdit by remember { mutableStateOf(false) }
    var showLocationEdit by remember { mutableStateOf(false) }
    // SH-132: each opening gets its own dialog view model (nothing typed and cancelled comes back).
    var locationOpenings by remember { mutableStateOf(0) }
    var showFinancialsEdit by remember { mutableStateOf(false) }
    var showLabourBudgetEdit by remember { mutableStateOf(false) }
    var showPayrollEdit by remember { mutableStateOf(false) }
    var showWorkforceEdit by remember { mutableStateOf(false) }
    var showAvailabilityEdit by remember { mutableStateOf(false) }
    var showSalesTargetEdit by remember { mutableStateOf(false) }
    var showNoShowEdit by remember { mutableStateOf(false) }
    // SH-223: the request types' numbers and the shared places.
    var showRequestsEdit by remember { mutableStateOf(false) }
    var renamingPlace by remember { mutableStateOf<com.evoapps.evoshift.domain.model.RequestPlace?>(null) }
    var removingPlace by remember { mutableStateOf<com.evoapps.evoshift.domain.model.RequestPlace?>(null) }
    var showChecklistAlertEdit by remember { mutableStateOf(false) }
    var showGeofenceEdit by remember { mutableStateOf(false) }
    var showBreaksEdit by remember { mutableStateOf(false) }
    var showClockReviewEdit by remember { mutableStateOf(false) }
    var showStaffChecksEdit by remember { mutableStateOf(false) }
    var showRestRulesEdit by remember { mutableStateOf(false) }
    // SH-226: weather for the workplace's location.
    var showWeatherEdit by remember { mutableStateOf(false) }
    var showWorkHoursEdit by remember { mutableStateOf(false) }
    var showRosterVisibilityEdit by remember { mutableStateOf(false) }
    var showFooterEdit by remember { mutableStateOf(false) }
    var showReportsEdit by remember { mutableStateOf(false) }
    // SH-227: school breaks and long weekends.
    var showSpecialDaysEdit by remember { mutableStateOf(false) }
    var showSundayEdit by remember { mutableStateOf(false) }
    var isMoreExpanded by remember { mutableStateOf(false) }
    var showRemoveConfirmDialog by remember { mutableStateOf(false) }


    val errorText = state.error?.asString()

    val successText = state.successMessage?.asString()

    // Leave once the workplace is gone, not before: a failed removal stays here with its error.
    LaunchedEffect(state.isRemoved) {
        if (state.isRemoved) onNavigateBack()
    }

    LaunchedEffect(errorText, successText) {
        errorText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(SettingsEvent.MessageShown)
        }
        successText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(SettingsEvent.MessageShown)
        }
    }

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        containerColor = Cream,
        topBar = {
            EvoTopBar(
                // SH-269: the group's settings say whose they are.
                title = state.group?.let { group ->
                    stringResource(Res.string.group_settings_source_group, if (group.usesDefaultName) stringResource(Res.string.workplace_groups_default_name) else group.name)
                } ?: stringResource(Res.string.settings_title),
                onBack = onNavigateBack,
                backDescription = stringResource(Res.string.cancel),
                actions = listOf(helpAction(HelpPage.WORKPLACE_SETTINGS))
            )
        }
    ) { padding ->
        val isExpanded = LocalWindowWidthClass.current.isExpanded
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
        ) {
            if (state.isLoading && state.workplace == null) {
                Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                    CircularProgressIndicator(color = DarkGold)
                }
            } else {
                state.workplace?.let { workplace ->
                    val settings = workplace.settings
                    // SH-269: the group's settings (the owner) instead of a workplace's.
                    val groupMode = state.isGroupMode
                    // Each section only for those who may change it (WORKPLACE_SETTINGS for the
                    // workplace itself - the screen's own gate -, WORKPLACE_FINANCES for its money,
                    // the owner removes it).
                    val finances = state.capabilities.shows(Gate.WORKPLACE_FINANCES)
                    // Read-only once the plan ended (SH-65): the sections show, without their edit buttons.
                    fun edit(open: () -> Unit): (() -> Unit)? = if (state.capabilities.shows(Gate.SETTINGS_EDITING)) open else null
                    fun editFinances(open: () -> Unit): (() -> Unit)? = if (state.capabilities.shows(Gate.WORKPLACE_FINANCES_EDITING)) open else null

                    ProvideSectionSources(sectionSources(state, viewModel::onEvent)) {
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .verticalScroll(rememberScrollState())
                            .contentWidth(if (isExpanded) WideContentMaxWidth else ContentMaxWidth)
                            .padding(16.dp),
                        verticalArrangement = Arrangement.spacedBy(16.dp)
                    ) {
                        if (groupMode) GroupSettingsIntroCard()
                        // Wide windows: the sections in two columns; phones and tablets keep one column
                        // of at most the reading width (SH-161).
                        ResponsiveColumns(
                            maxColumns = if (isExpanded) 2 else 1,
                            sections = listOfNotNull<@Composable () -> Unit>(
                                {
                                    // --- 1. General Settings ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_general_info),
                                        icon = Icons.Default.Business,
                                        onEdit = edit { showGeneralEdit = true },
                                        help = stringResource(Res.string.settings_help_general)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.REGION, com.evoapps.evoshift.domain.model.SettingsSection.SWAP_POLICY)
                                        if (!groupMode) DataRow(stringResource(Res.string.settings_name), workplace.name)
                                        DataRow(stringResource(Res.string.settings_currency), settings.currency)
                                        DataRow(stringResource(Res.string.settings_timezone), settings.timezone)
                                        DataRow(
                                            stringResource(Res.string.settings_first_day),
                                            if (settings.firstDayOfWeek == 1) stringResource(Res.string.day_monday) else stringResource(
                                                Res.string.day_sunday
                                            )
                                        )
                                        DataRow(
                                            stringResource(Res.string.settings_swap_policy),
                                            when(settings.shiftSwapPolicy) {
                                                SwapPolicy.A_DIRECT -> stringResource(Res.string.settings_policy_a_title)
                                                SwapPolicy.B_APPROVAL -> stringResource(Res.string.settings_policy_b_title)
                                                SwapPolicy.C_TRIAGE_DIRECT -> stringResource(Res.string.settings_policy_c_title)
                                                SwapPolicy.D_TRIAGE_APPROVAL -> stringResource(Res.string.settings_policy_d_title)
                                            }
                                        )
                                    }
                                },
                                if (groupMode) null else { {
                                    // --- 2. Location ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_location),
                                        icon = Icons.Default.Business, // or a Pin icon if available
                                        onEdit = edit { locationOpenings++; showLocationEdit = true }
                                    ) {
                                        DataRow(stringResource(Res.string.settings_address), workplace.address)
                                        DataRow(stringResource(Res.string.settings_geoplace), workplace.location?.format() ?: stringResource(Res.string.settings_none))
                                    }
                                } },
                                if (!finances) null else { {
                                    // --- 3. Financials ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_financials),
                                        icon = Icons.AutoMirrored.Filled.TrendingUp,
                                        onEdit = editFinances { showFinancialsEdit = true },
                                        help = stringResource(Res.string.settings_help_financials)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.INCOME, com.evoapps.evoshift.domain.model.SettingsSection.LABOUR_TARGETS)
                                        state.workplaceFinancials?.let { financials ->
                                            DataRow(
                                                stringResource(Res.string.settings_fixed_revenue),
                                                formatMoney(financials.fixedRevenueMonthly, settings.currency)
                                            )
                                            DataRow(
                                                stringResource(Res.string.settings_commission_percent),
                                                formatPercent(financials.commissionPercent * 100)
                                            )
                                            // SH-54, SH-95: the staffing hints' target, % of income (or the default for the commission).
                                            DataRow(
                                                stringResource(Res.string.settings_labour_target),
                                                financials.labourTargetPercent?.let { formatPercent(it) }
                                                    ?: stringResource(
                                                        Res.string.settings_labour_target_default,
                                                        formatPercent(settings.market.defaultLabourPercentFor(financials.commissionPercent))
                                                    )
                                            )
                                            // SH-120: the sales forecast's hours and people per hour of work.
                                            DataRow(
                                                stringResource(Res.string.settings_splh_goal),
                                                financials.salesPerLabourHourGoal?.let { formatMoney(it, settings.currency) }
                                                    ?: stringResource(Res.string.settings_splh_goal_default)
                                            )
                                        }
                                    }
                                } },
                                // --- 3a. Labour budget (SH-115): the finances' only, off by default ---
                                if (groupMode || !finances || state.labourBudget == null) null else { {
                                    val budget = state.labourBudget!!
                                    ProfileSection(
                                        title = stringResource(Res.string.labour_budget),
                                        icon = Icons.Default.AccountBalanceWallet,
                                        onEdit = editFinances { showLabourBudgetEdit = true },
                                        help = stringResource(Res.string.settings_help_labour_budget)
                                    ) {
                                        DataRow(
                                            stringResource(Res.string.settings_labour_budget_monthly),
                                            budget.monthly?.let { formatMoney(it, settings.currency) } ?: stringResource(Res.string.settings_labour_budget_off)
                                        )
                                        if (budget.isOn) {
                                            DataRow(
                                                stringResource(Res.string.settings_labour_budget_weekly),
                                                budget.weekly?.let { formatMoney(it, settings.currency) } ?: stringResource(Res.string.settings_none)
                                            )
                                        }
                                    }
                                } },
                                if (!finances) null else { {
                                    // --- 3b. Payroll (the market's labour law) ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_payroll),
                                        icon = Icons.Default.AccountBalance,
                                        onEdit = editFinances { showPayrollEdit = true },
                                        help = stringResource(Res.string.settings_help_payroll)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.PAYROLL)
                                        DataRow(stringResource(Res.string.settings_market), "${settings.market.flag} ${marketName(settings.market)}")
                                        DataRow(
                                            stringResource(Res.string.settings_accident_rate),
                                            "${formatDecimal(settings.payroll.accidentInsuranceRate * 100, 2)}%"
                                        )
                                        DataRow(stringResource(Res.string.settings_night_period), "${settings.payroll.nightStart}–${settings.payroll.nightEnd}")
                                        DataRow(
                                            stringResource(Res.string.settings_owner_unpaid),
                                            stringResource(if (settings.payroll.ownerShiftsUnpaid) Res.string.employee_yes else Res.string.employee_no)
                                        )
                                        DataRow(stringResource(Res.string.settings_settlement_period), settlementPeriodLabel(settings.payroll.settlementPeriodMonths))
                                        DataRow(
                                            stringResource(Res.string.settings_time_off_in_lieu),
                                            stringResource(if (settings.payroll.overtimeTimeOffInLieu) Res.string.employee_yes else Res.string.employee_no)
                                        )
                                        // SH-193: what unassigned shifts count at in the plan.
                                        DataRow(stringResource(Res.string.settings_open_shift_cost), openShiftCostLabel(settings.payroll.openShiftCost, settings.currency))
                                    }
                                } },
                                {
                                    // --- 4. Workforce ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_staff_skills),
                                        icon = Icons.Default.Groups,
                                        onEdit = edit { showWorkforceEdit = true },
                                        help = stringResource(Res.string.settings_help_staff_skills)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.ROLES_SKILLS)
                                        DataRow(
                                            stringResource(Res.string.settings_roles),
                                            if (settings.availableRoles.isEmpty()) stringResource(Res.string.settings_none) else settings.availableRoles.joinToString(
                                                ", "
                                            )
                                        )
                                        DataRow(
                                            stringResource(Res.string.settings_skills),
                                            if (settings.workplaceSkills.isEmpty()) stringResource(Res.string.settings_none) else settings.workplaceSkills.joinToString(
                                                ", "
                                            )
                                        )
                                        // SH-104: the positions and skills whose holders lead shifts.
                                        val leads = settings.availableRoles.filter { it in settings.leadRoles } +
                                            settings.workplaceSkills.filter { it in settings.leadSkills }
                                        DataRow(
                                            stringResource(Res.string.settings_lead_marks),
                                            if (leads.isEmpty()) stringResource(Res.string.settings_none) else leads.joinToString(", ")
                                        )
                                    }
                                },
                                {
                                    // --- 3. Availability Slots ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_availability_slots),
                                        icon = Icons.Default.Schedule,
                                        onEdit = edit { showAvailabilityEdit = true },
                                        help = stringResource(Res.string.settings_help_availability_slots)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.AVAILABILITY_SLOTS)
                                        if (settings.definedAvailabilitySlots.isEmpty()) {
                                            Text(
                                                stringResource(Res.string.settings_no_slots),
                                                style = MaterialTheme.typography.bodySmall,
                                                color = DeepNavy.copy(alpha = 0.5f)
                                            )
                                        } else {
                                            settings.definedAvailabilitySlots.forEach { slot ->
                                                DataRow(slot.label, "${slot.startTime} - ${slot.endTime}")
                                            }
                                        }
                                    }
                                },
                                {
                                    // --- 3b. No-show alerts (SH-73) ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_no_show),
                                        icon = Icons.Default.PersonOff,
                                        onEdit = edit { showNoShowEdit = true }
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.ALERTS)
                                        DataRow(stringResource(Res.string.settings_no_show_after), noShowLabel(settings.noShowAlertMinutes))
                                    }
                                },
                                {
                                    // --- 3a0. Request types (SH-223, SH-263): the ones switched on; Edit opens the dialog ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_request_types),
                                        icon = Icons.Default.EventNote,
                                        onEdit = edit { viewModel.onEvent(SettingsEvent.OpenRequestTypes) },
                                        help = stringResource(Res.string.settings_help_request_types)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.REQUESTS)
                                        RequestTypesCardContent(settings.requests)
                                    }
                                },
                                {
                                    // --- 3b0. Requests (SH-223): the numbers Polish law sets, and the shared places ---
                                    val requests = settings.requests.clamped()
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_requests),
                                        icon = Icons.Default.EventNote,
                                        onEdit = edit { showRequestsEdit = true },
                                        help = stringResource(Res.string.settings_help_requests)
                                    ) {
                                        DataRow(stringResource(Res.string.settings_blood_donation_days), stringResource(Res.string.settings_days_count, requests.bloodDonationDays))
                                        DataRow(stringResource(Res.string.settings_childcare_limit),
                                            stringResource(Res.string.settings_days_or_hours, requests.childcareDays, requests.childcareHours))
                                        DataRow(stringResource(Res.string.settings_force_majeure_limit),
                                            stringResource(Res.string.settings_days_or_hours, requests.forceMajeureDays, requests.forceMajeureHours))
                                        DataRow(stringResource(Res.string.settings_carer_leave_days), stringResource(Res.string.settings_days_count, requests.carerLeaveDays))
                                        DataRow(stringResource(Res.string.settings_care_allowance_days), stringResource(Res.string.settings_care_days,
                                            requests.careAllowanceChildDays, requests.careAllowanceFamilyDays, requests.careAllowanceTotalDays))
                                        if (!groupMode) {
                                        Spacer(Modifier.height(8.dp))
                                        Text(stringResource(Res.string.settings_work_places), style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = DeepNavy)
                                        if (state.places.isEmpty()) {
                                            Text(stringResource(Res.string.settings_work_places_empty), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.6f))
                                        }
                                        state.places.forEach { place ->
                                            Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                                                Text(place.name, style = MaterialTheme.typography.bodyMedium, color = DeepNavy, modifier = Modifier.weight(1f))
                                                if (state.capabilities.shows(Gate.SETTINGS_EDITING)) {
                                                    IconButtonWithTooltip(onClick = { renamingPlace = place }, tooltip = stringResource(Res.string.place_rename) + ": " + place.name) {
                                                        Icon(Icons.Default.Edit, contentDescription = stringResource(Res.string.place_rename) + ": " + place.name, tint = DeepNavy)
                                                    }
                                                    IconButtonWithTooltip(onClick = { removingPlace = place }, tooltip = stringResource(Res.string.place_remove) + ": " + place.name) {
                                                        Icon(Icons.Default.Delete, contentDescription = stringResource(Res.string.place_remove) + ": " + place.name, tint = Color(0xFFC62828))
                                                    }
                                                }
                                            }
                                        }
                                        }
                                    }
                                },
                                {
                                    // --- 3b'. Closing checklist reminders (SH-121) ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_checklist_alert),
                                        icon = Icons.Default.Checklist,
                                        onEdit = edit { showChecklistAlertEdit = true }
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.ALERTS)
                                        DataRow(stringResource(Res.string.settings_checklist_alert_after), noShowLabel(settings.checklistAlertMinutes))
                                    }
                                },
                                {
                                    // --- 3b''. Clock-in only near the workplace (SH-106) ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_geofence),
                                        icon = Icons.Default.MyLocation,
                                        onEdit = edit { showGeofenceEdit = true },
                                        help = stringResource(Res.string.settings_help_geofence)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.GEOFENCE)
                                        DataRow(stringResource(Res.string.settings_geofence_check), stringResource(geofenceModeTitleRes(settings.geofence.mode)))
                                        if (settings.geofence.mode != GeofenceMode.OFF) {
                                            DataRow(
                                                stringResource(Res.string.settings_geofence_radius),
                                                stringResource(Res.string.settings_geofence_meters, settings.geofence.radiusMeters)
                                            )
                                        }
                                    }
                                },
                                {
                                    // --- 3b'''. Breaks (SH-116): what is paid, the reminder ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_breaks),
                                        icon = Icons.Default.FreeBreakfast,
                                        onEdit = editFinances { showBreaksEdit = true },
                                        help = stringResource(Res.string.settings_help_breaks)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.BREAKS)
                                        DataRow(
                                            stringResource(Res.string.settings_break_paid),
                                            stringResource(if (settings.breakPolicy.paidBreak) Res.string.employee_yes else Res.string.employee_no)
                                        )
                                        DataRow(stringResource(Res.string.settings_break_unpaid), unpaidBreakLabel(settings.breakPolicy.unpaidBreakMinutes))
                                        DataRow(stringResource(Res.string.settings_break_reminder), breakReminderLabel(settings.breakPolicy.reminderAfterHours))
                                    }
                                },
                                {
                                    // --- 3b''''. Clock-in checks (SH-134): flags, payable time, tablet safeguards ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_clock_review),
                                        icon = Icons.Default.FactCheck,
                                        onEdit = editFinances { showClockReviewEdit = true },
                                        help = stringResource(Res.string.settings_help_clock_review)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.CLOCK_REVIEW)
                                        val review = settings.clockReview
                                        val yesNo = { on: Boolean -> if (on) Res.string.employee_yes else Res.string.employee_no }
                                        DataRow(stringResource(Res.string.settings_clock_early_in), clockMinutesLabel(review.earlyInMinutes))
                                        DataRow(stringResource(Res.string.settings_clock_late_out), clockMinutesLabel(review.lateOutMinutes))
                                        DataRow(stringResource(Res.string.settings_clock_overrun), clockMinutesLabel(review.maxOverrunMinutes))
                                        DataRow(stringResource(Res.string.settings_clock_very_short), clockMinutesLabel(review.veryShortMinutes))
                                        DataRow(stringResource(Res.string.settings_clock_count_from_plan), stringResource(yesNo(review.countFromPlannedStart)))
                                        DataRow(stringResource(Res.string.settings_clock_qr_only), stringResource(yesNo(review.kioskQrOnly)))
                                        DataRow(stringResource(Res.string.settings_clock_same_tablet), clockSecondsLabel(review.sameTabletSeconds))
                                        DataRow(stringResource(Res.string.settings_clock_no_app), stringResource(yesNo(review.flagNoAppActivity)))
                                        DataRow(stringResource(Res.string.settings_clock_photo), stringResource(yesNo(review.kioskPhoto)))
                                    }
                                },
                                if (groupMode) null else { {
                                    // --- 3b'. The clock-in tablet (SH-107): pairing, the list, unpairing ---
                                    com.evoapps.evoshift.ui.kiosk.KioskDevicesSection(
                                        workplaceId = workplace.id,
                                        onMessage = { snackbarHostState.showSnackbar(it) },
                                        canEdit = state.capabilities.shows(Gate.SETTINGS_EDITING)
                                    )
                                } },
                                // --- 3c. Expired medical exams / OHS training (SH-47): the HR side's ---
                                if (!state.capabilities.shows(Gate.STAFF_RECORDS)) null else { {
                                    ProfileSection(
                                        title = stringResource(Res.string.staff_checks_title),
                                        icon = Icons.Default.HealthAndSafety,
                                        onEdit = if (state.capabilities.shows(Gate.STAFF_RECORDS_EDITING)) { { showStaffChecksEdit = true } } else null,
                                        help = stringResource(Res.string.settings_block_expired_hint)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.STAFF_CHECKS)
                                        DataRow(
                                            stringResource(Res.string.settings_block_expired),
                                            stringResource(if (settings.blockExpiredStaffChecks) Res.string.settings_block_expired_on else Res.string.settings_block_expired_off)
                                        )
                                    }
                                } },
                                {
                                    // --- 3c'. Rest between shifts for every contract (SH-133) ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_rest_rules_title),
                                        icon = Icons.Default.Bedtime,
                                        onEdit = edit { showRestRulesEdit = true },
                                        help = stringResource(Res.string.settings_rest_rules_hint)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.REST_RULES)
                                        DataRow(
                                            stringResource(Res.string.settings_rest_rules),
                                            stringResource(if (settings.restRulesForAllContracts) Res.string.settings_rest_rules_on else Res.string.settings_rest_rules_off)
                                        )
                                    }
                                },
                                {
                                    // --- SH-257: the team enters their own working hours ---
                                    ProfileSection(
                                        title = stringResource(Res.string.work_hours_title),
                                        icon = Icons.Default.Schedule,
                                        onEdit = edit { showWorkHoursEdit = true },
                                        help = stringResource(Res.string.workplace_work_hours_self_entry_hint)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.WORK_HOURS)
                                        DataRow(
                                            stringResource(Res.string.workplace_work_hours_self_entry),
                                            stringResource(if (settings.workHours.selfEntry) Res.string.settings_weather_on else Res.string.settings_weather_off)
                                        )
                                    }
                                },
                                {
                                    // --- SH-255: what employees see of colleagues' shifts (owners and managers) ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_roster_visibility_title),
                                        icon = Icons.Default.VisibilityOff,
                                        onEdit = edit { showRosterVisibilityEdit = true },
                                        help = stringResource(Res.string.settings_roster_visibility_hint)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.ROSTER_VISIBILITY)
                                        Box(Modifier.testTag(ROSTER_VISIBILITY_ROW_TAG)) {
                                            DataRow(stringResource(Res.string.settings_roster_visibility), rosterVisibilityTitle(settings.rosterVisibility))
                                        }
                                        if (settings.rosterHasHiddenPeople) {
                                            Text(
                                                stringResource(Res.string.settings_roster_visibility_hidden_people),
                                                style = MaterialTheme.typography.bodySmall,
                                                color = DeepNavy.copy(alpha = 0.7f),
                                                modifier = Modifier.padding(top = 4.dp)
                                            )
                                        }
                                    }
                                },
                                {
                                    // --- 3c''. Weather for the location (SH-226), owners and managers ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_weather_title),
                                        icon = Icons.Default.WbSunny,
                                        onEdit = edit { showWeatherEdit = true },
                                        help = stringResource(Res.string.settings_weather_hint)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.WEATHER)
                                        DataRow(
                                            stringResource(Res.string.settings_weather),
                                            stringResource(if (settings.weatherEnabled) Res.string.settings_weather_on else Res.string.settings_weather_off)
                                        )
                                        // Where the data comes from, always in sight (the licences ask for the credit).
                                        Text(
                                            stringResource(Res.string.settings_weather_sources),
                                            style = MaterialTheme.typography.bodySmall,
                                            color = DeepNavy.copy(alpha = 0.7f),
                                            modifier = Modifier.padding(top = 4.dp).testTag(WEATHER_SETTING_SOURCES_TAG)
                                        )
                                        if (settings.weatherEnabled && workplace.location == null) {
                                            Text(
                                                stringResource(Res.string.settings_weather_needs_location),
                                                style = MaterialTheme.typography.bodySmall,
                                                color = MaterialTheme.colorScheme.error,
                                                modifier = Modifier.padding(top = 4.dp)
                                            )
                                        }
                                    }
                                },
                                {
                                    // --- SH-239: "Made with EVoShift" on the e-mailed rosters (hidden on paid plans only) ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_footer_title),
                                        icon = Icons.Default.Campaign,
                                        onEdit = edit { showFooterEdit = true },
                                        help = stringResource(Res.string.settings_footer_hint)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.FOOTER)
                                        Box(Modifier.testTag(FOOTER_SETTING_ROW_TAG)) {
                                            DataRow(
                                                stringResource(Res.string.settings_footer),
                                                stringResource(
                                                    if (settings.showEvoShiftFooter || !state.footerCanBeHidden) Res.string.settings_footer_on
                                                    else Res.string.settings_footer_off
                                                )
                                            )
                                        }
                                        if (!state.footerCanBeHidden) {
                                            Text(
                                                stringResource(Res.string.settings_footer_paid_only),
                                                style = MaterialTheme.typography.bodySmall,
                                                color = DeepNavy.copy(alpha = 0.7f),
                                                modifier = Modifier.padding(top = 4.dp)
                                            )
                                        }
                                    }
                                },
                                {
                                    // --- SH-258: how the printed working-time record looks ---
                                    ReportSettingsSection(settings.reports.timesheet, onEdit = edit { showReportsEdit = true }) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.REPORTS)
                                    }
                                },
                                {
                                    // --- 3c'''. School breaks and long weekends (SH-227), next to the weather ---
                                    val found = com.evoapps.evoshift.domain.specialdays.VoivodeshipFinder.of(workplace)
                                    val poland = settings.market == com.evoapps.evoshift.domain.market.Market.POLAND
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_special_days_title),
                                        icon = Icons.Default.Weekend,
                                        onEdit = edit { showSpecialDaysEdit = true },
                                        help = stringResource(Res.string.settings_special_days_hint)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.SPECIAL_DAYS)
                                        DataRow(
                                            stringResource(Res.string.settings_special_days),
                                            stringResource(if (settings.specialDaysEnabled) Res.string.settings_special_days_on else Res.string.settings_special_days_off)
                                        )
                                        if (settings.specialDaysEnabled && poland) {
                                            if (found != null) {
                                                DataRow(
                                                    stringResource(Res.string.settings_special_days_voivodeship),
                                                    if (found.source == com.evoapps.evoshift.domain.specialdays.VoivodeshipFinder.Source.ADDRESS) {
                                                        stringResource(Res.string.settings_special_days_voivodeship_found, found.voivodeship.polishName)
                                                    } else found.voivodeship.polishName
                                                )
                                            } else {
                                                // No winter break without a voivodeship: say so where it is chosen.
                                                Text(
                                                    stringResource(Res.string.settings_special_days_voivodeship_unknown),
                                                    style = MaterialTheme.typography.bodySmall,
                                                    color = MaterialTheme.colorScheme.error,
                                                    modifier = Modifier.padding(top = 4.dp).testTag(SPECIAL_DAYS_UNKNOWN_TAG)
                                                )
                                            }
                                        }
                                    }
                                },
                                {
                                    // --- 3c. Sundays and holidays (SH-55) ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_sunday),
                                        icon = Icons.Default.Event,
                                        onEdit = edit { showSundayEdit = true },
                                        help = stringResource(Res.string.settings_help_sunday)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.SUNDAYS)
                                        DataRow(stringResource(Res.string.settings_sunday_policy), stringResource(sundayPolicyTitleRes(settings.sundayPolicy)))
                                    }
                                },
                                if (!finances) null else { {
                                    // --- 4. Sales Targets ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_sales_targets),
                                        icon = Icons.AutoMirrored.Filled.TrendingUp,
                                        onEdit = editFinances { showSalesTargetEdit = true },
                                        help = stringResource(Res.string.settings_help_sales_targets)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.SALES_TARGETS)
                                        // SH-208: the week's days, with a scrollbar for the mouse when they do not fit.
                                        ScrollingRow(
                                            modifier = Modifier.fillMaxWidth(),
                                            horizontalArrangement = Arrangement.spacedBy(16.dp)
                                        ) {
                                            val days = listOf(
                                                stringResource(Res.string.day_mon_short) to DayOfWeek.MONDAY,
                                                stringResource(Res.string.day_tue_short) to DayOfWeek.TUESDAY,
                                                stringResource(Res.string.day_wed_short) to DayOfWeek.WEDNESDAY,
                                                stringResource(Res.string.day_thu_short) to DayOfWeek.THURSDAY,
                                                stringResource(Res.string.day_fri_short) to DayOfWeek.FRIDAY,
                                                stringResource(Res.string.day_sat_short) to DayOfWeek.SATURDAY,
                                                stringResource(Res.string.day_sun_short) to DayOfWeek.SUNDAY
                                            )
                                            days.forEach { (label, key) ->
                                                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                                                    Text(
                                                        label.uppercase(),
                                                        style = MaterialTheme.typography.labelSmall,
                                                        color = DeepNavy.copy(alpha = 0.4f)
                                                    )
                                                    Text(
                                                        formatMoney(state.workplaceFinancials?.salesTargetFor(key) ?: 0.0, settings.currency),
                                                        style = MaterialTheme.typography.bodyMedium,
                                                        fontWeight = FontWeight.Bold,
                                                        color = DeepNavy
                                                    )
                                                }
                                            }
                                        }
                                    }
                                } },
                                if (groupMode) { {
                                    // SH-269: the group's templates come from one of its workplaces.
                                    GroupTemplatesCard(
                                        workplaces = state.group?.workplaces.orEmpty(),
                                        canEdit = state.capabilities.shows(Gate.SETTINGS_EDITING),
                                        onUseTemplatesFrom = { viewModel.onEvent(SettingsEvent.UseTemplatesFrom(it)) }
                                    )
                                } } else if (!state.capabilities.shows(Gate.SETTINGS_EDITING)) null else { {
                                    // --- 5. Roster Blueprint ---
                                    ProfileSection(
                                        title = stringResource(Res.string.settings_roster_blueprint),
                                        icon = Icons.Default.EditCalendar,
                                        onEdit = null,
                                        help = stringResource(Res.string.settings_help_roster_blueprint)
                                    ) {
                                        SectionSourceRow(com.evoapps.evoshift.domain.model.SettingsSection.TEMPLATES)
                                        Text(
                                            stringResource(Res.string.settings_roster_blueprint_desc),
                                            style = MaterialTheme.typography.bodySmall,
                                            color = DeepNavy.copy(alpha = 0.7f)
                                        )
                                        Spacer(Modifier.height(12.dp))
                                        Box(
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .height(44.dp)
                                                .background(GoldMetallicBrush, RoundedCornerShape(8.dp))
                                                .handCursor()
                                                .clip(RoundedCornerShape(8.dp))
                                                .clickable { onNavigateToTemplateEditor() },
                                            contentAlignment = Alignment.Center
                                        ) {
                                            Text(
                                                stringResource(Res.string.settings_edit_weekly_skeleton),
                                                fontWeight = FontWeight.Bold,
                                                color = DeepNavy
                                            )
                                        }
                                    }
                                } }
                            )
                        )

                        // --- 6. More Section (removing the workplace: the owner only) ---
                        if (!groupMode && state.capabilities.shows(Gate.DELETE_WORKPLACE)) RegularCard(
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Column {
                                Row(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .handCursor()
                                        .clickable { isMoreExpanded = !isMoreExpanded }
                                        .padding(horizontal = 16.dp, vertical = 16.dp),
                                    horizontalArrangement = Arrangement.SpaceBetween,
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        Icon(
                                            imageVector = Icons.Default.Settings,
                                            contentDescription = null,
                                            tint = DeepNavy,
                                            modifier = Modifier.size(20.dp)
                                        )
                                        Spacer(modifier = Modifier.width(12.dp))
                                        Text(
                                            text = stringResource(Res.string.settings_more),
                                            style = MaterialTheme.typography.titleSmall,
                                            fontWeight = FontWeight.Bold,
                                            color = DeepNavy
                                        )
                                    }
                                    Icon(
                                        imageVector = if (isMoreExpanded) Icons.Default.ExpandLess else Icons.Default.ExpandMore,
                                        contentDescription = null,
                                        tint = DeepNavy
                                    )
                                }

                                AnimatedVisibility(
                                    visible = isMoreExpanded,
                                    enter = expandVertically(animationSpec = tween(300)),
                                    exit = shrinkVertically(animationSpec = tween(300))
                                ) {
                                    Column(
                                        modifier = Modifier.padding(16.dp),
                                        verticalArrangement = Arrangement.spacedBy(16.dp)
                                    ) {
                                        HorizontalDivider(color = DeepNavy.copy(alpha = 0.1f))
                                        // GDPR: export before deleting; the server decides the scope by role (SH-27).
                                        state.workplace?.id?.let { DataExportEntry(workplaceId = it) }

                                        OutlinedButton(
                                            onClick = { showRemoveConfirmDialog = true },
                                            colors = ButtonDefaults.outlinedButtonColors(
                                                contentColor = Color(0xFFD32F2F)
                                            ),
                                            border = BorderStroke(1.dp, Color(0xFFD32F2F)),
                                            modifier = Modifier.fillMaxWidth()
                                        ) {
                                            Icon(Icons.Default.Delete, contentDescription = null)
                                            Spacer(Modifier.width(8.dp))
                                            Text(stringResource(Res.string.settings_remove_workspace))
                                        }
                                    }
                                }
                            }
                        }

                        Spacer(Modifier.height(32.dp))
                    }
                    }
                }
            }
        }
    }

    // --- DIALOGS ---

    // SH-263: the request types' dialog, then a type's settings over it.
    state.requestTypesDraft?.let { draft ->
        RequestTypesDialog(draft = draft, customContractTypes = state.customContractTypes, onEvent = viewModel::onEvent)
    }
    state.requestTypeDraft?.let { typeDraft ->
        RequestTypeDetail(
            draft = typeDraft,
            columns = contractColumns(state.customContractTypes),
            wide = LocalWindowWidthClass.current != WindowWidthClass.COMPACT,
            canEdit = state.capabilities.shows(Gate.SETTINGS_EDITING),
            onEvent = viewModel::onEvent
        )
    }

    // 1. General Settings Dialog (Includes Swap Policy)
    if (showGeneralEdit) {
        state.workplace?.let { workplace ->
            GeneralSettingsDialog(
                initialName = workplace.name,
                // SH-269: a group is renamed on the groups screen.
                showName = !state.isGroupMode,
                initialCurrency = workplace.settings.currency,
                initialTimezone = workplace.settings.timezone,
                initialFirstDay = workplace.settings.firstDayOfWeek,
                initialSwapPolicy = workplace.settings.shiftSwapPolicy,
                onDismiss = { showGeneralEdit = false },
                onSave = { name, currency, timezone, firstDay, swapPolicy ->
                    viewModel.onEvent(
                        SettingsEvent.UpdateBasicSettings(
                            name,
                            timezone,
                            currency,
                            firstDay
                        )
                    )
                    viewModel.onEvent(SettingsEvent.ChangeSwapPolicy(swapPolicy))
                    showGeneralEdit = false
                }
            )
        }
    }

    if (showLocationEdit) {
        state.workplace?.let { workplace ->
            WorkplaceLocationDialog(
                workplaceId = workplace.id,
                market = workplace.settings.market,
                initialAddress = workplace.address,
                initialLocation = workplace.location,
                opening = locationOpenings,
                onDismiss = { showLocationEdit = false },
                onSave = { address, location ->
                    viewModel.onEvent(SettingsEvent.UpdateLocation(address, location))
                    showLocationEdit = false
                }
            )
        }
    }

    if (showPayrollEdit) {
        state.workplace?.let { workplace ->
            PayrollSettingsDialog(
                initial = workplace.settings.payroll,
                currency = workplace.settings.currency,
                onDismiss = { showPayrollEdit = false },
                onSave = {
                    viewModel.onEvent(SettingsEvent.UpdatePayroll(it))
                    showPayrollEdit = false
                }
            )
        }
    }

    if (showFinancialsEdit) {
        state.workplaceFinancials?.let { financials ->
            FinancialsSettingsDialog(
                initialFinancials = financials,
                market = state.workplace?.settings?.market ?: Market.POLAND,
                currency = state.workplace?.settings?.currency.orEmpty(),
                // SH-269: sections following the group show its values greyed; empty is the group's.
                groupIncome = state.groupValuesIfFollowed(com.evoapps.evoshift.domain.model.SettingsSection.INCOME)?.financials,
                groupLabourTargets = state.groupValuesIfFollowed(com.evoapps.evoshift.domain.model.SettingsSection.LABOUR_TARGETS)?.financials,
                onDismiss = { showFinancialsEdit = false },
                onSave = { newFinancials, toGroup ->
                    viewModel.onEvent(SettingsEvent.UpdateFinancials(newFinancials))
                    toGroup.forEach { viewModel.onEvent(SettingsEvent.SetSectionSource(it, com.evoapps.evoshift.domain.model.SectionSource.GROUP)) }
                    showFinancialsEdit = false
                }
            )
        }
    }

    if (showLabourBudgetEdit) {
        state.labourBudget?.let { budget ->
            LabourBudgetDialog(
                initial = budget,
                currency = state.workplace?.settings?.currency.orEmpty(),
                onDismiss = { showLabourBudgetEdit = false },
                onSave = { newBudget ->
                    viewModel.onEvent(SettingsEvent.UpdateLabourBudget(newBudget))
                    showLabourBudgetEdit = false
                }
            )
        }
    }

    // 2. Workforce Dialog (Roles & Skills): every change is saved at once, so it only closes.
    if (showWorkforceEdit) {
        state.workplace?.let { workplace ->
            EvoDialog(
                title = stringResource(Res.string.settings_edit_staff_skills),
                subtitle = stringResource(Res.string.dialog_saved_live),
                icon = Icons.Default.Groups,
                onDismiss = { showWorkforceEdit = false },
                confirm = DialogAction(stringResource(Res.string.done), { showWorkforceEdit = false }),
                dismiss = null,
                bodyArrangement = Arrangement.spacedBy(24.dp)
            ) {
                StringListEditor(
                    title = stringResource(Res.string.settings_available_roles),
                    items = workplace.settings.availableRoles,
                    hint = stringResource(Res.string.settings_role_hint),
                    onAdd = { viewModel.onEvent(SettingsEvent.AddRole(it)) },
                    onRemove = { viewModel.onEvent(SettingsEvent.RemoveRole(it)) }
                )
                StringListEditor(
                    title = stringResource(Res.string.settings_workplace_skills),
                    items = workplace.settings.workplaceSkills,
                    hint = stringResource(Res.string.settings_skill_hint),
                    onAdd = { viewModel.onEvent(SettingsEvent.AddSkill(it)) },
                    onRemove = { viewModel.onEvent(SettingsEvent.RemoveSkill(it)) }
                )
                // SH-104: which positions and skills lead shifts (with the owner and managers).
                val settings = workplace.settings
                if (settings.availableRoles.isNotEmpty() || settings.workplaceSkills.isNotEmpty()) {
                    DialogSection(stringResource(Res.string.settings_lead_marks)) {
                        Text(
                            stringResource(Res.string.settings_lead_marks_hint),
                            color = Color.White.copy(alpha = 0.6f),
                            style = MaterialTheme.typography.bodySmall
                        )
                        Column {
                            settings.availableRoles.forEach { role ->
                                EvoCheckboxRow(
                                    checked = role in settings.leadRoles,
                                    onCheckedChange = { viewModel.onEvent(SettingsEvent.SetLeadRole(role, it)) },
                                    label = role,
                                    supporting = stringResource(Res.string.settings_lead_mark_role)
                                )
                            }
                            settings.workplaceSkills.forEach { skill ->
                                EvoCheckboxRow(
                                    checked = skill in settings.leadSkills,
                                    onCheckedChange = { viewModel.onEvent(SettingsEvent.SetLeadSkill(skill, it)) },
                                    label = skill,
                                    supporting = stringResource(Res.string.settings_lead_mark_skill)
                                )
                            }
                        }
                    }
                }
            }
        }
    }

    if (showStaffChecksEdit) {
        state.workplace?.let { workplace ->
            var block by remember { mutableStateOf(workplace.settings.blockExpiredStaffChecks) }
            EvoDialog(
                title = stringResource(Res.string.staff_checks_title),
                icon = Icons.Default.HealthAndSafety,
                onDismiss = { showStaffChecksEdit = false },
                confirm = DialogAction(stringResource(Res.string.save), {
                    viewModel.onEvent(SettingsEvent.UpdateBlockExpiredStaffChecks(block))
                    showStaffChecksEdit = false
                })
            ) {
                DialogSection(stringResource(Res.string.settings_block_expired)) {
                    EvoSwitchRow(
                        checked = block,
                        onCheckedChange = { block = it },
                        label = stringResource(Res.string.settings_block_expired_switch),
                        supporting = stringResource(Res.string.settings_block_expired_hint)
                    )
                }
            }
        }
    }

    if (showWorkHoursEdit) {
        state.workplace?.let { workplace ->
            var on by remember { mutableStateOf(workplace.settings.workHours.selfEntry) }
            EvoDialog(
                title = stringResource(Res.string.work_hours_title),
                icon = Icons.Default.Schedule,
                onDismiss = { showWorkHoursEdit = false },
                confirm = DialogAction(stringResource(Res.string.save), {
                    viewModel.onEvent(SettingsEvent.UpdateWorkHours(com.evoapps.evoshift.domain.model.WorkHoursSettings(on)))
                    showWorkHoursEdit = false
                })
            ) {
                EvoSwitchRow(
                    checked = on,
                    onCheckedChange = { on = it },
                    label = stringResource(Res.string.workplace_work_hours_self_entry),
                    supporting = stringResource(Res.string.workplace_work_hours_self_entry_hint),
                    modifier = Modifier.testTag(WORK_HOURS_SETTING_SWITCH_TAG)
                )
            }
        }
    }

    if (showWeatherEdit) {
        state.workplace?.let { workplace ->
            var on by remember { mutableStateOf(workplace.settings.weatherEnabled) }
            EvoDialog(
                title = stringResource(Res.string.settings_weather_title),
                icon = Icons.Default.WbSunny,
                onDismiss = { showWeatherEdit = false },
                confirm = DialogAction(stringResource(Res.string.save), {
                    viewModel.onEvent(SettingsEvent.UpdateWeatherEnabled(on))
                    showWeatherEdit = false
                })
            ) {
                DialogSection(stringResource(Res.string.settings_weather)) {
                    EvoSwitchRow(
                        checked = on,
                        onCheckedChange = { on = it },
                        label = stringResource(Res.string.settings_weather_switch),
                        supporting = stringResource(Res.string.settings_weather_hint),
                        modifier = Modifier.testTag(WEATHER_SETTING_SWITCH_TAG)
                    )
                    Text(
                        stringResource(if (workplace.location == null) Res.string.settings_weather_needs_location else Res.string.settings_weather_sources),
                        style = MaterialTheme.typography.bodySmall
                    )
                }
            }
        }
    }

    if (showReportsEdit) {
        state.workplace?.let { workplace ->
            TimesheetReportDialog(
                initial = workplace.settings.reports.timesheet,
                onDismiss = { showReportsEdit = false },
                onSave = {
                    viewModel.onEvent(SettingsEvent.UpdateTimesheetReport(it))
                    showReportsEdit = false
                }
            )
        }
    }

    if (showRosterVisibilityEdit) {
        state.workplace?.let { workplace ->
            var visibility by remember { mutableStateOf(workplace.settings.rosterVisibility) }
            EvoDialog(
                title = stringResource(Res.string.settings_roster_visibility_title),
                icon = Icons.Default.VisibilityOff,
                onDismiss = { showRosterVisibilityEdit = false },
                confirm = DialogAction(stringResource(Res.string.save), {
                    viewModel.onEvent(SettingsEvent.UpdateRosterVisibility(visibility))
                    showRosterVisibilityEdit = false
                })
            ) {
                DialogSection(stringResource(Res.string.settings_roster_visibility)) {
                    EvoRadioGroup(
                        options = RosterVisibility.entries,
                        selected = visibility,
                        onSelect = { visibility = it },
                        optionLabel = { rosterVisibilityTitle(it) },
                        description = { rosterVisibilityDescription(it) },
                        modifier = Modifier.testTag(ROSTER_VISIBILITY_OPTIONS_TAG)
                    )
                    Text(stringResource(Res.string.settings_roster_visibility_hint), style = MaterialTheme.typography.bodySmall)
                }
            }
        }
    }

    if (showFooterEdit) {
        state.workplace?.let { workplace ->
            var show by remember { mutableStateOf(workplace.settings.showEvoShiftFooter || !state.footerCanBeHidden) }
            EvoDialog(
                title = stringResource(Res.string.settings_footer_title),
                icon = Icons.Default.Campaign,
                onDismiss = { showFooterEdit = false },
                confirm = DialogAction(stringResource(Res.string.save), {
                    viewModel.onEvent(SettingsEvent.UpdateEvoShiftFooter(show))
                    showFooterEdit = false
                })
            ) {
                DialogSection(stringResource(Res.string.settings_footer)) {
                    EvoSwitchRow(
                        checked = show,
                        onCheckedChange = { show = it },
                        label = stringResource(Res.string.settings_footer_switch),
                        supporting = stringResource(Res.string.settings_footer_hint),
                        enabled = state.footerCanBeHidden,
                        modifier = Modifier.testTag(FOOTER_SETTING_SWITCH_TAG)
                    )
                    if (!state.footerCanBeHidden) {
                        Text(stringResource(Res.string.settings_footer_paid_only), style = MaterialTheme.typography.bodySmall)
                    }
                }
            }
        }
    }

    if (showSpecialDaysEdit) {
        state.workplace?.let { workplace ->
            SpecialDaysSettingDialog(
                workplace = workplace,
                onDismiss = { showSpecialDaysEdit = false },
                onSave = { on, voivodeship ->
                    viewModel.onEvent(SettingsEvent.UpdateSpecialDays(on, voivodeship))
                    showSpecialDaysEdit = false
                }
            )
        }
    }

    if (showRestRulesEdit) {
        state.workplace?.let { workplace ->
            var all by remember { mutableStateOf(workplace.settings.restRulesForAllContracts) }
            EvoDialog(
                title = stringResource(Res.string.settings_rest_rules_title),
                icon = Icons.Default.Bedtime,
                onDismiss = { showRestRulesEdit = false },
                confirm = DialogAction(stringResource(Res.string.save), {
                    viewModel.onEvent(SettingsEvent.UpdateRestRulesForAllContracts(all))
                    showRestRulesEdit = false
                })
            ) {
                DialogSection(stringResource(Res.string.settings_rest_rules)) {
                    EvoSwitchRow(
                        checked = all,
                        onCheckedChange = { all = it },
                        label = stringResource(Res.string.settings_rest_rules_switch),
                        supporting = stringResource(Res.string.settings_rest_rules_hint)
                    )
                }
            }
        }
    }

    if (showGeofenceEdit) {
        state.workplace?.let { workplace ->
            GeofenceDialog(
                initial = workplace.settings.geofence,
                hasLocation = workplace.location != null,
                onDismiss = { showGeofenceEdit = false },
                onSave = { geofence ->
                    viewModel.onEvent(SettingsEvent.UpdateGeofence(geofence))
                    showGeofenceEdit = false
                }
            )
        }
    }

    if (showClockReviewEdit) {
        state.workplace?.let { workplace ->
            ClockReviewDialog(
                initial = workplace.settings.clockReview,
                onDismiss = { showClockReviewEdit = false },
                onSave = { review ->
                    viewModel.onEvent(SettingsEvent.UpdateClockReview(review))
                    showClockReviewEdit = false
                }
            )
        }
    }
    if (showBreaksEdit) {
        state.workplace?.let { workplace ->
            BreakPolicyDialog(
                initial = workplace.settings.breakPolicy,
                onDismiss = { showBreaksEdit = false },
                onSave = { policy ->
                    viewModel.onEvent(SettingsEvent.UpdateBreakPolicy(policy))
                    showBreaksEdit = false
                }
            )
        }
    }

    if (showRequestsEdit) {
        state.workplace?.let { workplace ->
            RequestSettingsDialog(
                initial = workplace.settings.requests,
                onDismiss = { showRequestsEdit = false },
                onSave = { requests ->
                    viewModel.onEvent(SettingsEvent.UpdateRequestSettings(requests))
                    showRequestsEdit = false
                }
            )
        }
    }
    renamingPlace?.let { place ->
        var name by remember(place.id) { mutableStateOf(place.name) }
        EvoDialog(
            title = stringResource(Res.string.place_rename_title),
            icon = Icons.Default.Edit,
            onDismiss = { renamingPlace = null },
            width = com.evoapps.evoshift.widgets.DialogWidth.Compact,
            confirm = DialogAction(stringResource(Res.string.save), {
                if (name.isNotBlank()) viewModel.onEvent(SettingsEvent.RenamePlace(place.id, name))
                renamingPlace = null
            })
        ) {
            EvoTextField(value = name, onValueChange = { name = it.take(com.evoapps.evoshift.domain.usecase.requests.WorkPlacesUseCase.MAX_NAME) },
                label = stringResource(Res.string.place_new_label))
        }
    }
    removingPlace?.let { place ->
        com.evoapps.evoshift.widgets.EvoConfirmDialog(
            title = stringResource(Res.string.place_remove),
            text = stringResource(Res.string.place_remove_confirm, place.name),
            confirmLabel = stringResource(Res.string.place_remove),
            onConfirm = {
                viewModel.onEvent(SettingsEvent.RemovePlace(place.id))
                removingPlace = null
            },
            onDismiss = { removingPlace = null },
            destructive = true
        )
    }

    if (showNoShowEdit) {
        state.workplace?.let { workplace ->
            NoShowAlertDialog(
                initialMinutes = workplace.settings.noShowAlertMinutes,
                onDismiss = { showNoShowEdit = false },
                onSave = { minutes ->
                    viewModel.onEvent(SettingsEvent.UpdateNoShowAlert(minutes))
                    showNoShowEdit = false
                }
            )
        }
    }

    if (showChecklistAlertEdit) {
        state.workplace?.let { workplace ->
            ChecklistAlertDialog(
                initialMinutes = workplace.settings.checklistAlertMinutes,
                onDismiss = { showChecklistAlertEdit = false },
                onSave = { minutes ->
                    viewModel.onEvent(SettingsEvent.UpdateChecklistAlert(minutes))
                    showChecklistAlertEdit = false
                }
            )
        }
    }

    if (showSundayEdit) {
        state.workplace?.let { workplace ->
            SundayPolicyDialog(
                initial = workplace.settings.sundayPolicy,
                onDismiss = { showSundayEdit = false },
                onSave = { policy ->
                    viewModel.onEvent(SettingsEvent.UpdateSundayPolicy(policy))
                    showSundayEdit = false
                }
            )
        }
    }

    // 3. Availability Slots Dialog: removals and additions are saved at once; new slots are
    // added in place (no second dialog on top of this one).
    if (showAvailabilityEdit) {
        state.workplace?.let { workplace ->
            AvailabilitySlotsDialog(
                slots = workplace.settings.definedAvailabilitySlots,
                onDismiss = { showAvailabilityEdit = false },
                onRemove = { viewModel.onEvent(SettingsEvent.RemoveAvailabilitySlot(it.id)) },
                onAdd = { label, start, end ->
                    viewModel.onEvent(
                        SettingsEvent.AddAvailabilitySlot(
                            AvailabilitySlot(
                                id = "slot_${now().toEpochMilliseconds()}",
                                label = label,
                                startTime = start,
                                endTime = end
                            )
                        )
                    )
                }
            )
        }
    }

    // 4. Sales Targets Dialog
    if (showSalesTargetEdit) {
        val currentTargets = state.workplaceFinancials ?: WorkplaceFinancials()
        SalesTargetsDialog(
            initialTargets = currentTargets,
            currency = state.workplace?.settings?.currency.orEmpty(),
            // SH-269: following the group, its targets show greyed; an empty day is the group's.
            groupTargets = state.groupValuesIfFollowed(com.evoapps.evoshift.domain.model.SettingsSection.SALES_TARGETS)?.financials,
            onDismiss = { showSalesTargetEdit = false },
            onSave = { newTargets ->
                viewModel.onEvent(SettingsEvent.UpdateSalesTargets(newTargets))
                showSalesTargetEdit = false
            }
        )
    }

    // Closes by itself when a removal fails (the error shows in the snackbar).
    LaunchedEffect(state.isSaving) {
        if (!state.isSaving && !state.isRemoved) showRemoveConfirmDialog = false
    }

    if (showRemoveConfirmDialog) {
        EvoConfirmDialog(
            title = stringResource(Res.string.settings_remove_workspace),
            text = stringResource(Res.string.settings_remove_workspace_confirm),
            confirmLabel = stringResource(Res.string.settings_remove_workspace),
            onConfirm = { viewModel.onEvent(SettingsEvent.RemoveWorkspace) },
            onDismiss = { showRemoveConfirmDialog = false },
            destructive = true,
            icon = Icons.Default.Delete,
            loading = state.isSaving
        )
    }
}

@Composable
fun marketName(market: Market): String = when (market) {
    Market.POLAND -> stringResource(Res.string.market_poland)
}

/** "3 months" (SH-57). */
@Composable
fun settlementPeriodLabel(months: Int): String = stringResource(
    when (months) {
        2 -> Res.string.settings_settlement_months_2
        3 -> Res.string.settings_settlement_months_3
        4 -> Res.string.settings_settlement_months_4
        else -> Res.string.settings_settlement_months_1
    }
)

/**
 * Accident insurance rate, the night period, the owner's unpaid shifts, the settlement period and
 * time off in lieu of overtime pay (SH-57), checked before saving.
 */
@Composable
fun PayrollSettingsDialog(
    initial: WorkplacePayrollSettings,
    currency: String = "",
    onDismiss: () -> Unit,
    onSave: (WorkplacePayrollSettings) -> Unit
) {
    var accidentRate by remember { mutableStateOf(formatEditable(initial.accidentInsuranceRate * 100)) }
    var nightStart by remember { mutableStateOf(initial.nightStart) }
    var nightEnd by remember { mutableStateOf(initial.nightEnd) }
    var ownerUnpaid by remember { mutableStateOf(initial.ownerShiftsUnpaid) }
    var settlementMonths by remember { mutableStateOf(initial.settlementPeriodMonths) }
    var timeOffInLieu by remember { mutableStateOf(initial.overtimeTimeOffInLieu) }
    // SH-193: unassigned shifts' cost per hour in the plan.
    var openMode by remember { mutableStateOf(initial.openShiftCost.mode) }
    var openRate by remember { mutableStateOf(initial.openShiftCost.validPerHour?.let { formatEditable(it) } ?: "") }
    val openRateAmount = parseDecimal(openRate)?.takeIf { OpenShiftCostSetting.isValidPerHour(it) }
    // Fixed needs a rate; automatic takes an empty one (no fallback) or a valid one.
    val openValid = if (openMode == OpenShiftCostMode.FIXED) openRateAmount != null else openRate.isBlank() || openRateAmount != null

    val rate = parseDecimal(accidentRate)?.takeIf { it in 0.0..10.0 }
    val start = parseClockTime(nightStart)
    val end = parseClockTime(nightEnd)
    val valid = rate != null && start != null && end != null && openValid

    EvoDialog(
        title = stringResource(Res.string.settings_edit_payroll),
        icon = Icons.Default.AccountBalance,
        onDismiss = onDismiss,
        confirm = DialogAction(
            stringResource(Res.string.save),
            {
                if (rate != null && start != null && end != null) {
                    onSave(
                        initial.copy(
                            accidentInsuranceRate = rate / 100, nightStart = start, nightEnd = end, ownerShiftsUnpaid = ownerUnpaid,
                            settlementPeriodMonths = settlementMonths, overtimeTimeOffInLieu = timeOffInLieu,
                            openShiftCost = OpenShiftCostSetting(openMode, openRateAmount)
                        )
                    )
                }
            },
            enabled = valid
        )
    ) {
        EvoTextField(
            value = accidentRate,
            onValueChange = { accidentRate = it },
            label = stringResource(Res.string.settings_accident_rate),
            keyboardType = KeyboardType.Decimal,
            supportingText = stringResource(Res.string.settings_accident_rate_hint),
            error = stringResource(Res.string.accident_rate_invalid).takeIf { rate == null },
            suffix = "%"
        )
        DialogSection(stringResource(Res.string.settings_night_period)) {
            Text(
                stringResource(Res.string.settings_night_hint),
                style = MaterialTheme.typography.bodySmall,
                color = Color.White.copy(alpha = 0.6f)
            )
            Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                EvoTimeField(
                    value = nightStart,
                    onValueChange = { nightStart = it },
                    label = stringResource(Res.string.settings_night_start),
                    showErrors = true,
                    modifier = Modifier.weight(1f)
                )
                EvoTimeField(
                    value = nightEnd,
                    onValueChange = { nightEnd = it },
                    label = stringResource(Res.string.settings_night_end),
                    showErrors = true,
                    imeAction = ImeAction.Done,
                    modifier = Modifier.weight(1f)
                )
            }
        }
        EvoCheckboxRow(
            checked = ownerUnpaid,
            onCheckedChange = { ownerUnpaid = it },
            label = stringResource(Res.string.settings_owner_unpaid),
            supporting = stringResource(Res.string.settings_owner_unpaid_hint)
        )
        DialogSection(stringResource(Res.string.settings_settlement_period)) {
            Text(
                stringResource(Res.string.settings_settlement_period_hint),
                style = MaterialTheme.typography.bodySmall,
                color = Color.White.copy(alpha = 0.6f)
            )
            EvoSegmented(
                options = WorkplacePayrollSettings.SETTLEMENT_PERIOD_CHOICES,
                selected = settlementMonths,
                onSelect = { settlementMonths = it },
                optionLabel = { it.toString() }
            )
        }
        EvoCheckboxRow(
            checked = timeOffInLieu,
            onCheckedChange = { timeOffInLieu = it },
            label = stringResource(Res.string.settings_time_off_in_lieu),
            supporting = stringResource(Res.string.settings_time_off_in_lieu_hint)
        )
        DialogSection(stringResource(Res.string.settings_open_shift_cost)) {
            Text(
                stringResource(Res.string.settings_open_shift_cost_hint),
                style = MaterialTheme.typography.bodySmall,
                color = Color.White.copy(alpha = 0.6f)
            )
            EvoSegmented(
                options = OpenShiftCostMode.entries,
                selected = openMode,
                onSelect = { openMode = it },
                optionLabel = { stringResource(openShiftCostModeRes(it)) }
            )
            if (openMode == OpenShiftCostMode.AUTOMATIC) {
                Text(
                    stringResource(Res.string.settings_open_shift_cost_automatic_hint),
                    style = MaterialTheme.typography.bodySmall,
                    color = Color.White.copy(alpha = 0.6f)
                )
            }
            EvoTextField(
                value = openRate,
                onValueChange = { openRate = it },
                label = stringResource(
                    if (openMode == OpenShiftCostMode.FIXED) Res.string.settings_open_shift_cost_rate else Res.string.settings_open_shift_cost_rate_optional
                ),
                keyboardType = KeyboardType.Decimal,
                error = stringResource(Res.string.settings_open_shift_cost_invalid).takeIf { !openValid && (openRate.isNotBlank() || openMode == OpenShiftCostMode.FIXED) },
                suffix = currency.takeIf { it.isNotBlank() }?.let { "$it/h" }
            )
        }
    }
}

/** SH-193: the two ways of choosing unassigned shifts' cost per hour. */
private fun openShiftCostModeRes(mode: OpenShiftCostMode) = when (mode) {
    OpenShiftCostMode.AUTOMATIC -> Res.string.settings_open_shift_cost_automatic
    OpenShiftCostMode.FIXED -> Res.string.settings_open_shift_cost_fixed
}

/** SH-193: "Automatic", or "Fixed rate: 31 zł/h". */
@Composable
private fun openShiftCostLabel(setting: OpenShiftCostSetting, currency: String): String {
    val rate = setting.validPerHour
    return if (setting.mode == OpenShiftCostMode.FIXED && rate != null) {
        stringResource(Res.string.settings_open_shift_cost_fixed_value, formatSpmhOrDash(rate, currency))
    } else stringResource(Res.string.settings_open_shift_cost_automatic)
}

/**
 * SH-115: the labour budget: on or off, the monthly amount and an optional weekly one (each above
 * zero). Off by default; switching it off keeps nothing.
 */
@Composable
fun LabourBudgetDialog(
    initial: LabourBudget,
    currency: String,
    onDismiss: () -> Unit,
    onSave: (LabourBudget) -> Unit
) {
    var on by remember { mutableStateOf(initial.isOn) }
    var monthly by remember { mutableStateOf(initial.monthly?.let { formatEditable(it) } ?: "") }
    var weekly by remember { mutableStateOf(initial.weekly?.let { formatEditable(it) } ?: "") }
    val monthlyAmount = parseDecimal(monthly)?.takeIf { LabourBudget.isValidAmount(it) }
    // Empty is no weekly budget; anything else must be an amount above zero.
    val weeklyAmount = if (weekly.isBlank()) null else parseDecimal(weekly)?.takeIf { LabourBudget.isValidAmount(it) }
    val weeklyValid = weekly.isBlank() || weeklyAmount != null
    val valid = !on || (monthlyAmount != null && weeklyValid)
    val invalid = stringResource(Res.string.settings_labour_budget_invalid)

    EvoDialog(
        title = stringResource(Res.string.settings_edit_labour_budget),
        icon = Icons.Default.AccountBalanceWallet,
        onDismiss = onDismiss,
        confirm = DialogAction(
            stringResource(Res.string.save),
            { if (valid) onSave(if (on) LabourBudget(monthlyAmount, weeklyAmount) else LabourBudget.OFF) },
            enabled = valid
        )
    ) {
        EvoSwitchRow(
            checked = on,
            onCheckedChange = { on = it },
            label = stringResource(Res.string.settings_labour_budget_enable),
            supporting = stringResource(Res.string.settings_labour_budget_hint)
        )
        if (on) {
            EvoTextField(
                value = monthly,
                onValueChange = { monthly = it },
                label = stringResource(Res.string.settings_labour_budget_monthly),
                keyboardType = KeyboardType.Decimal,
                error = invalid.takeIf { monthly.isNotBlank() && monthlyAmount == null },
                suffix = currency
            )
            EvoTextField(
                value = weekly,
                onValueChange = { weekly = it },
                label = stringResource(Res.string.settings_labour_budget_weekly),
                keyboardType = KeyboardType.Decimal,
                imeAction = ImeAction.Done,
                supportingText = stringResource(Res.string.settings_labour_budget_weekly_hint),
                error = invalid.takeIf { !weeklyValid },
                suffix = currency
            )
        }
    }
}

@Composable
fun FinancialsSettingsDialog(
    initialFinancials: WorkplaceFinancials,
    /** SH-54: whose default labour target applies while the field is empty. */
    market: Market = Market.POLAND,
    currency: String,
    /**
     * SH-269: the group's values while the workplace follows the group in its income (or labour
     * targets): those fields start empty with the group's values greyed in; typing makes them the
     * workplace's own, leaving all of a section empty keeps the group's.
     */
    groupIncome: WorkplaceFinancials? = null,
    groupLabourTargets: WorkplaceFinancials? = null,
    onDismiss: () -> Unit,
    /** The values to save, and the sections left empty to follow the group again. */
    onSave: (WorkplaceFinancials, Set<com.evoapps.evoshift.domain.model.SettingsSection>) -> Unit
) {
    val incomeFromGroup = groupIncome != null
    val targetsFromGroup = groupLabourTargets != null
    var fixedRevenue by remember { mutableStateOf(if (incomeFromGroup) "" else formatEditable(initialFinancials.fixedRevenueMonthly)) }
    var commissionPercent by remember { mutableStateOf(if (incomeFromGroup) "" else formatEditable(initialFinancials.commissionPercent * 100)) }
    var labourTarget by remember { mutableStateOf(if (targetsFromGroup) "" else initialFinancials.labourTargetPercent?.let { formatEditable(it) } ?: "") }
    var perHourGoal by remember { mutableStateOf(if (targetsFromGroup) "" else initialFinancials.salesPerLabourHourGoal?.let { formatEditable(it) } ?: "") }
    val keepGroupIncome = incomeFromGroup && fixedRevenue.isBlank() && commissionPercent.isBlank()
    val keepGroupTargets = targetsFromGroup && labourTarget.isBlank() && perHourGoal.isBlank()

    // Empty means zero (following the group: the group's value); anything else must be a number.
    val revenue = if (fixedRevenue.isBlank()) groupIncome?.fixedRevenueMonthly ?: 0.0 else parseDecimal(fixedRevenue)
    val commission = if (commissionPercent.isBlank()) (groupIncome?.commissionPercent ?: 0.0) * 100 else parseDecimal(commissionPercent)
    // SH-54, SH-95: empty is the default for the commission; otherwise 1–100 (a share of income).
    val labour = if (labourTarget.isBlank()) groupLabourTargets?.labourTargetPercent else parseDecimal(labourTarget)
    val labourValid = labourTarget.isBlank() || (labour != null && labour in LabourTarget.MIN_PERCENT..LabourTarget.MAX_PERCENT)
    // SH-120: empty is the workplace's own recent figure; otherwise above zero.
    val perHour = if (perHourGoal.isBlank()) groupLabourTargets?.salesPerLabourHourGoal else parseDecimal(perHourGoal)
    val perHourValid = perHourGoal.isBlank() || (perHour != null && perHour > 0)
    val groupHint = stringResource(Res.string.group_settings_placeholder_hint)
    val commissionFraction = (commission ?: 0.0) / 100.0
    val defaultLabour = market.defaultLabourPercentFor(commissionFraction)
    val numberError = stringResource(Res.string.number_invalid)

    EvoDialog(
        title = stringResource(Res.string.settings_edit_financials),
        icon = Icons.AutoMirrored.Filled.TrendingUp,
        onDismiss = onDismiss,
        confirm = DialogAction(
            stringResource(Res.string.save),
            {
                if (revenue != null && commission != null && labourValid && perHourValid) {
                    onSave(
                        initialFinancials.copy(
                            fixedRevenueMonthly = revenue,
                            commissionPercent = commission / 100.0,
                            // No longer a choice: the fixed revenue always counts in the days (kept as stored).
                            includeFixedRevenueInDailyFinancialReport = initialFinancials.includeFixedRevenueInDailyFinancialReport,
                            labourTargetPercent = labour,
                            labourTargetConvertedFromSales = null,
                            salesPerLabourHourGoal = perHour
                        ),
                        setOfNotNull(
                            com.evoapps.evoshift.domain.model.SettingsSection.INCOME.takeIf { keepGroupIncome },
                            com.evoapps.evoshift.domain.model.SettingsSection.LABOUR_TARGETS.takeIf { keepGroupTargets }
                        )
                    )
                }
            },
            enabled = revenue != null && commission != null && labourValid && perHourValid
        )
    ) {
        EvoTextField(
            value = fixedRevenue,
            onValueChange = { fixedRevenue = it },
            label = stringResource(Res.string.settings_fixed_revenue),
            keyboardType = KeyboardType.Decimal,
            placeholder = groupIncome?.let { formatEditable(it.fixedRevenueMonthly) },
            error = numberError.takeIf { revenue == null },
            supportingText = if (incomeFromGroup) groupHint else stringResource(Res.string.settings_fixed_revenue_hint),
            suffix = currency
        )
        EvoTextField(
            value = commissionPercent,
            onValueChange = { commissionPercent = it },
            label = stringResource(Res.string.settings_commission_percent),
            keyboardType = KeyboardType.Decimal,
            imeAction = ImeAction.Done,
            placeholder = groupIncome?.let { formatEditable(it.commissionPercent * 100) },
            supportingText = if (incomeFromGroup) groupHint else stringResource(Res.string.settings_commission_hint),
            error = numberError.takeIf { commission == null },
            suffix = "%"
        )
        EvoTextField(
            value = labourTarget,
            onValueChange = { labourTarget = it },
            label = stringResource(Res.string.settings_labour_target),
            keyboardType = KeyboardType.Decimal,
            imeAction = ImeAction.Done,
            placeholder = groupLabourTargets?.labourTargetPercent?.let { formatEditable(it) },
            supportingText = if (targetsFromGroup) groupHint else stringResource(Res.string.settings_labour_target_hint, formatPercent(defaultLabour)),
            error = stringResource(Res.string.settings_labour_target_invalid).takeIf { !labourValid },
            suffix = "%"
        )
        // SH-95: the target as a share of the sales, for orientation (with a commission below 100%).
        val shownTarget = if (labourTarget.isBlank()) defaultLabour else labour?.takeIf { labourValid }
        if (shownTarget != null && commissionFraction > 0 && commissionFraction < 1) {
            Text(
                stringResource(
                    Res.string.settings_labour_target_sales_equivalent,
                    formatPercent(shownTarget),
                    formatPercent(LabourShare.salesEquivalent(shownTarget, commissionFraction)),
                    formatPercent(commissionFraction * 100)
                ),
                // Inside the navy dialog: inherit its white text.
                style = MaterialTheme.typography.bodySmall
            )
        }
        // SH-95: a target saved before as a share of sales was converted on reading.
        initialFinancials.labourTargetConvertedFromSales?.let { fromSales ->
            Text(
                stringResource(
                    Res.string.settings_labour_target_converted,
                    formatPercent(fromSales),
                    formatPercent(initialFinancials.commissionPercent * 100)
                ),
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.tertiary
            )
        }
        EvoTextField(
            value = perHourGoal,
            onValueChange = { perHourGoal = it },
            label = stringResource(Res.string.settings_splh_goal),
            keyboardType = KeyboardType.Decimal,
            imeAction = ImeAction.Done,
            placeholder = groupLabourTargets?.salesPerLabourHourGoal?.let { formatEditable(it) },
            supportingText = if (targetsFromGroup) groupHint else stringResource(Res.string.settings_splh_goal_hint),
            error = stringResource(Res.string.settings_splh_goal_invalid).takeIf { !perHourValid },
            suffix = currency
        )
    }
}

@Composable
fun GeneralSettingsDialog(
    initialName: String,
    showName: Boolean = true,
    initialCurrency: String,
    initialTimezone: String,
    initialFirstDay: Int,
    initialSwapPolicy: SwapPolicy,
    onDismiss: () -> Unit,
    onSave: (String, String, String, Int, SwapPolicy) -> Unit
) {
    var name by remember { mutableStateOf(initialName) }
    var currency by remember { mutableStateOf(initialCurrency) }
    var timezone by remember { mutableStateOf(initialTimezone) }
    var firstDay by remember { mutableStateOf(initialFirstDay) }
    var swapPolicy by remember { mutableStateOf(initialSwapPolicy) }
    val required = stringResource(Res.string.field_required)

    EvoDialog(
        title = stringResource(Res.string.settings_general_settings),
        icon = Icons.Default.Business,
        onDismiss = onDismiss,
        dismissOnClickOutside = false,
        bodyArrangement = Arrangement.spacedBy(24.dp),
        confirm = DialogAction(
            stringResource(Res.string.save),
            { onSave(name.trim(), currency.trim().uppercase(), timezone.trim(), firstDay, swapPolicy) },
            enabled = name.isNotBlank() && currency.isNotBlank() && timezone.isNotBlank()
        )
    ) {
        DialogSection(stringResource(Res.string.dialog_section_basics)) {
            if (showName) EvoTextField(
                value = name,
                onValueChange = { name = it },
                label = stringResource(Res.string.settings_workplace_name),
                error = required.takeIf { name.isBlank() }
            )
            Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                EvoTextField(
                    value = currency,
                    onValueChange = { currency = it.take(3) },
                    label = stringResource(Res.string.settings_currency),
                    capitalization = KeyboardCapitalization.Characters,
                    error = required.takeIf { currency.isBlank() },
                    modifier = Modifier.weight(1f)
                )
                EvoTextField(
                    value = timezone,
                    onValueChange = { timezone = it },
                    label = stringResource(Res.string.settings_timezone),
                    capitalization = KeyboardCapitalization.None,
                    imeAction = ImeAction.Done,
                    error = required.takeIf { timezone.isBlank() },
                    modifier = Modifier.weight(2f)
                )
            }
        }

        DialogSection(stringResource(Res.string.settings_first_day_of_week)) {
            EvoRadioGroup(
                options = listOf(1, 7),
                selected = firstDay,
                onSelect = { firstDay = it },
                optionLabel = { if (it == 1) stringResource(Res.string.day_monday) else stringResource(Res.string.day_sunday) },
                horizontal = true
            )
        }

        DialogSection(stringResource(Res.string.settings_swap_policy)) {
            EvoRadioGroup(
                options = SwapPolicy.entries,
                selected = swapPolicy,
                onSelect = { swapPolicy = it },
                optionLabel = { swapPolicyTitle(it) },
                description = { swapPolicyDescription(it) }
            )
        }
    }
}

@Composable
private fun swapPolicyTitle(policy: SwapPolicy): String = stringResource(
    when (policy) {
        SwapPolicy.A_DIRECT -> Res.string.settings_policy_a_title
        SwapPolicy.B_APPROVAL -> Res.string.settings_policy_b_title
        SwapPolicy.C_TRIAGE_DIRECT -> Res.string.settings_policy_c_title
        SwapPolicy.D_TRIAGE_APPROVAL -> Res.string.settings_policy_d_title
    }
)

@Composable
private fun swapPolicyDescription(policy: SwapPolicy): String = stringResource(
    when (policy) {
        SwapPolicy.A_DIRECT -> Res.string.settings_policy_a_desc
        SwapPolicy.B_APPROVAL -> Res.string.settings_policy_b_desc
        SwapPolicy.C_TRIAGE_DIRECT -> Res.string.settings_policy_c_desc
        SwapPolicy.D_TRIAGE_APPROVAL -> Res.string.settings_policy_d_desc
    }
)

/** The workplace's availability slots: remove one, or add one in place below the list. */
@Composable
fun AvailabilitySlotsDialog(
    slots: List<AvailabilitySlot>,
    onDismiss: () -> Unit,
    onRemove: (AvailabilitySlot) -> Unit,
    onAdd: (label: String, start: String, end: String) -> Unit
) {
    var adding by remember { mutableStateOf(slots.isEmpty()) }
    var label by remember { mutableStateOf("") }
    var start by remember { mutableStateOf("08:00") }
    var end by remember { mutableStateOf("16:00") }
    var triedToAdd by remember { mutableStateOf(false) }

    val startTime = parseClockTime(start)
    val endTime = parseClockTime(end)
    val sameTimes = startTime != null && startTime == endTime

    fun add() {
        triedToAdd = true
        if (label.isNotBlank() && startTime != null && endTime != null && !sameTimes) {
            onAdd(label.trim(), startTime, endTime)
            label = ""
            triedToAdd = false
            adding = false
        }
    }

    EvoDialog(
        title = stringResource(Res.string.settings_edit_availability_slots),
        subtitle = stringResource(Res.string.dialog_saved_live),
        icon = Icons.Default.Schedule,
        onDismiss = onDismiss,
        confirm = DialogAction(stringResource(Res.string.done), onDismiss),
        dismiss = null,
        bodyArrangement = Arrangement.spacedBy(8.dp)
    ) {
        if (slots.isEmpty()) {
            Text(
                stringResource(Res.string.settings_no_slots),
                color = Color.White.copy(alpha = 0.6f),
                style = MaterialTheme.typography.bodyMedium
            )
        }
        slots.forEach { slot ->
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(12.dp))
                    .background(Color.White.copy(alpha = 0.06f))
                    .padding(start = 16.dp, top = 8.dp, bottom = 8.dp, end = 4.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(Modifier.weight(1f)) {
                    Text(slot.label, fontWeight = FontWeight.Bold, color = Color.White)
                    Text(
                        "${slot.startTime} – ${slot.endTime}",
                        style = MaterialTheme.typography.bodySmall,
                        color = LightGold.copy(alpha = 0.8f)
                    )
                }
                IconButtonWithTooltip(onClick = { onRemove(slot) }, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.delete)) {
                    Icon(Icons.Default.Delete, stringResource(Res.string.delete), tint = ErrorOnNavy)
                }
            }
        }

        Spacer(Modifier.height(8.dp))
        AnimatedVisibility(
            visible = adding,
            enter = expandVertically(animationSpec = tween(200)),
            exit = shrinkVertically(animationSpec = tween(200))
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(16.dp))
                    .border(1.dp, DarkGold.copy(alpha = 0.4f), RoundedCornerShape(16.dp))
                    .padding(16.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                DialogSectionLabel(stringResource(Res.string.settings_new_slot_title))
                EvoTextField(
                    value = label,
                    onValueChange = { label = it },
                    label = stringResource(Res.string.settings_slot_label_hint),
                    error = stringResource(Res.string.settings_slot_label_required).takeIf { triedToAdd && label.isBlank() }
                )
                Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    EvoTimeField(
                        value = start,
                        onValueChange = { start = it },
                        label = stringResource(Res.string.roster_from),
                        showErrors = triedToAdd,
                        modifier = Modifier.weight(1f)
                    )
                    EvoTimeField(
                        value = end,
                        onValueChange = { end = it },
                        label = stringResource(Res.string.roster_to),
                        showErrors = triedToAdd,
                        error = stringResource(Res.string.time_same_start_end).takeIf { sameTimes },
                        imeAction = ImeAction.Done,
                        modifier = Modifier.weight(1f)
                    )
                }
                Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    if (slots.isNotEmpty()) {
                        EvoSecondaryButton(
                            DialogAction(stringResource(Res.string.cancel), { adding = false; triedToAdd = false }),
                            Modifier.weight(1f)
                        )
                    }
                    EvoPrimaryButton(
                        DialogAction(stringResource(Res.string.settings_add_new_slot), { add() }, icon = Icons.Default.Add),
                        Modifier.weight(1f)
                    )
                }
            }
        }
        if (!adding) {
            EvoSecondaryButton(
                DialogAction(stringResource(Res.string.settings_add_new_slot), { adding = true }, icon = Icons.Default.Add),
                Modifier.fillMaxWidth()
            )
        }
    }
}

@Composable
fun SalesTargetsDialog(
    initialTargets: WorkplaceFinancials,
    currency: String,
    /** SH-269: the group's targets while the workplace follows them (placeholders; an empty day is the group's). */
    groupTargets: WorkplaceFinancials? = null,
    onDismiss: () -> Unit,
    onSave: (Map<String, Double>) -> Unit
) {
    val days = listOf(
        stringResource(Res.string.day_monday) to DayOfWeek.MONDAY,
        stringResource(Res.string.day_tuesday) to DayOfWeek.TUESDAY,
        stringResource(Res.string.day_wednesday) to DayOfWeek.WEDNESDAY,
        stringResource(Res.string.day_thursday) to DayOfWeek.THURSDAY,
        stringResource(Res.string.day_friday) to DayOfWeek.FRIDAY,
        stringResource(Res.string.day_saturday) to DayOfWeek.SATURDAY,
        stringResource(Res.string.day_sunday) to DayOfWeek.SUNDAY
    )
    var targets by remember {
        mutableStateOf(days.associate { (_, day) -> day to (if (groupTargets != null) "" else initialTargets.salesTargetFor(day)?.let { formatEditable(it) } ?: "") })
    }
    // Empty means no target (zero), or the group's while following it; anything else must be a number.
    val parsed = targets.mapValues { (day, value) -> if (value.isBlank()) groupTargets?.salesTargetFor(day) ?: 0.0 else parseDecimal(value) }
    val numberError = stringResource(Res.string.number_invalid)
    val wide = LocalWindowWidthClass.current != WindowWidthClass.COMPACT

    EvoDialog(
        title = stringResource(Res.string.settings_edit_sales_targets),
        icon = Icons.AutoMirrored.Filled.TrendingUp,
        onDismiss = onDismiss,
        bodyArrangement = Arrangement.spacedBy(12.dp),
        confirm = DialogAction(
            stringResource(Res.string.save),
            // Saved under the full day names the daily records read (SH-51).
            { onSave(parsed.entries.associate { (day, value) -> WorkplaceFinancials.salesTargetKey(day) to (value ?: 0.0) }) },
            enabled = parsed.values.none { it == null }
        )
    ) {
        // Two columns where there is room: a week of targets then fits without scrolling.
        days.chunked(if (wide) 2 else 1).forEach { row ->
            Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                row.forEach { (label, key) ->
                    val last = key == days.last().second
                    EvoTextField(
                        value = targets[key] ?: "",
                        onValueChange = { newValue -> targets = targets + (key to newValue) },
                        label = label,
                        keyboardType = KeyboardType.Decimal,
                        imeAction = if (last) ImeAction.Done else ImeAction.Next,
                        error = numberError.takeIf { parsed[key] == null },
                        placeholder = groupTargets?.salesTargetFor(key)?.let { formatEditable(it) },
                        suffix = currency,
                        modifier = Modifier.weight(1f)
                    )
                }
                if (row.size == 1 && wide) Spacer(Modifier.weight(1f))
            }
        }
    }
}

/** "15 min", or "Off" for 0. */
@Composable
private fun noShowLabel(minutes: Int): String =
    if (minutes <= 0) stringResource(Res.string.settings_no_show_off) else stringResource(Res.string.settings_no_show_minutes, minutes)

@Composable
private fun unpaidBreakLabel(minutes: Int): String =
    if (minutes <= 0) stringResource(Res.string.settings_break_none) else stringResource(Res.string.settings_break_minutes, minutes)

@Composable
private fun breakReminderLabel(hours: Int): String =
    if (hours <= 0) stringResource(Res.string.settings_break_reminder_off) else stringResource(Res.string.settings_break_reminder_after, hours)

@Composable
private fun clockMinutesLabel(minutes: Int): String =
    if (minutes <= 0) stringResource(Res.string.settings_clock_off) else stringResource(Res.string.settings_clock_minutes, minutes)

@Composable
private fun clockSecondsLabel(seconds: Int): String =
    if (seconds <= 0) stringResource(Res.string.settings_clock_off) else stringResource(Res.string.settings_clock_seconds, seconds)

/**
 * SH-134: the clock-in checks: when a clock time is flagged for review, whether pay counts from
 * the planned start, and the tablet's safeguards (QR only, pattern flags, the optional photo with
 * its data protection note).
 */
@Composable
fun ClockReviewDialog(initial: ClockReviewSettings, onDismiss: () -> Unit, onSave: (ClockReviewSettings) -> Unit) {
    var review by remember { mutableStateOf(initial) }
    EvoDialog(
        title = stringResource(Res.string.settings_edit_clock_review),
        icon = Icons.Default.FactCheck,
        onDismiss = onDismiss,
        confirm = DialogAction(stringResource(Res.string.save), { onSave(review) })
    ) {
        Text(stringResource(Res.string.settings_clock_review_explained), color = Color.White.copy(alpha = 0.85f))
        @Composable
        fun minutes(title: org.jetbrains.compose.resources.StringResource, choices: List<Int>, value: Int, onSelect: (Int) -> Unit) {
            DialogSection(stringResource(title)) {
                EvoRadioGroup(
                    options = (choices + value).distinct().sorted(),
                    selected = value,
                    onSelect = onSelect,
                    optionLabel = { clockMinutesLabel(it) }
                )
            }
        }
        minutes(Res.string.settings_clock_early_in, ClockReviewSettings.EARLY_IN_CHOICES, review.earlyInMinutes) { review = review.copy(earlyInMinutes = it) }
        minutes(Res.string.settings_clock_late_out, ClockReviewSettings.LATE_OUT_CHOICES, review.lateOutMinutes) { review = review.copy(lateOutMinutes = it) }
        minutes(Res.string.settings_clock_overrun, ClockReviewSettings.OVERRUN_CHOICES, review.maxOverrunMinutes) { review = review.copy(maxOverrunMinutes = it) }
        minutes(Res.string.settings_clock_very_short, ClockReviewSettings.VERY_SHORT_CHOICES, review.veryShortMinutes) { review = review.copy(veryShortMinutes = it) }
        EvoSwitchRow(
            checked = review.countFromPlannedStart,
            onCheckedChange = { review = review.copy(countFromPlannedStart = it) },
            label = stringResource(Res.string.settings_clock_count_from_plan),
            supporting = stringResource(Res.string.settings_clock_count_from_plan_explained)
        )
        EvoSwitchRow(
            checked = review.kioskQrOnly,
            onCheckedChange = { review = review.copy(kioskQrOnly = it) },
            label = stringResource(Res.string.settings_clock_qr_only),
            supporting = stringResource(Res.string.settings_clock_qr_only_explained)
        )
        DialogSection(stringResource(Res.string.settings_clock_same_tablet)) {
            EvoRadioGroup(
                options = (ClockReviewSettings.SAME_TABLET_CHOICES + review.sameTabletSeconds).distinct().sorted(),
                selected = review.sameTabletSeconds,
                onSelect = { review = review.copy(sameTabletSeconds = it) },
                optionLabel = { clockSecondsLabel(it) }
            )
        }
        EvoSwitchRow(
            checked = review.flagNoAppActivity,
            onCheckedChange = { review = review.copy(flagNoAppActivity = it) },
            label = stringResource(Res.string.settings_clock_no_app),
            supporting = stringResource(Res.string.settings_clock_no_app_explained)
        )
        EvoSwitchRow(
            checked = review.kioskPhoto,
            onCheckedChange = { review = review.copy(kioskPhoto = it) },
            label = stringResource(Res.string.settings_clock_photo),
            supporting = stringResource(Res.string.settings_clock_photo_explained)
        )
    }
}

/** SH-116: the paid break (on by law), the unpaid break's length and the reminder. */
@Composable
fun BreakPolicyDialog(initial: BreakPolicy, onDismiss: () -> Unit, onSave: (BreakPolicy) -> Unit) {
    var paid by remember { mutableStateOf(initial.paidBreak) }
    var unpaid by remember { mutableStateOf(initial.unpaidBreakMinutes) }
    var reminder by remember { mutableStateOf(initial.reminderAfterHours) }
    EvoDialog(
        title = stringResource(Res.string.settings_edit_breaks),
        icon = Icons.Default.FreeBreakfast,
        onDismiss = onDismiss,
        confirm = DialogAction(stringResource(Res.string.save), { onSave(BreakPolicy(paid, unpaid, reminder)) })
    ) {
        Text(stringResource(Res.string.settings_help_breaks), color = Color.White.copy(alpha = 0.85f))
        EvoSwitchRow(
            checked = paid,
            onCheckedChange = { paid = it },
            label = stringResource(Res.string.settings_break_paid)
        )
        DialogSection(stringResource(Res.string.settings_break_unpaid)) {
            EvoRadioGroup(
                options = (BreakPolicy.UNPAID_BREAK_CHOICES + initial.unpaidBreakMinutes).distinct().sorted(),
                selected = unpaid,
                onSelect = { unpaid = it },
                optionLabel = { unpaidBreakLabel(it) }
            )
        }
        DialogSection(stringResource(Res.string.settings_break_reminder)) {
            EvoRadioGroup(
                options = (BreakPolicy.REMINDER_CHOICES + initial.reminderAfterHours).distinct().sorted(),
                selected = reminder,
                onSelect = { reminder = it },
                optionLabel = { breakReminderLabel(it) }
            )
        }
    }
}

/** How long after a shift's start without a clock-in the managers are told (SH-73). */
@Composable
fun NoShowAlertDialog(initialMinutes: Int, onDismiss: () -> Unit, onSave: (Int) -> Unit) {
    val choices = (WorkplaceSettings.NO_SHOW_ALERT_CHOICES + initialMinutes).distinct().sorted()
    var minutes by remember { mutableStateOf(initialMinutes) }
    EvoDialog(
        title = stringResource(Res.string.settings_no_show),
        icon = Icons.Default.PersonOff,
        onDismiss = onDismiss,
        confirm = DialogAction(stringResource(Res.string.save), { onSave(minutes) })
    ) {
        Text(stringResource(Res.string.settings_no_show_desc), color = Color.White.copy(alpha = 0.85f))
        DialogSection(stringResource(Res.string.settings_no_show_after)) {
            EvoRadioGroup(
                options = choices,
                selected = minutes,
                onSelect = { minutes = it },
                optionLabel = { noShowLabel(it) }
            )
        }
    }
}

/** SH-121: how long after a shift its closing checklist may stay unfinished before the reminder. */
@Composable
fun ChecklistAlertDialog(initialMinutes: Int, onDismiss: () -> Unit, onSave: (Int) -> Unit) {
    val choices = (WorkplaceSettings.CHECKLIST_ALERT_CHOICES + initialMinutes).distinct().sorted()
    var minutes by remember { mutableStateOf(initialMinutes) }
    EvoDialog(
        title = stringResource(Res.string.settings_checklist_alert),
        icon = Icons.Default.Checklist,
        onDismiss = onDismiss,
        confirm = DialogAction(stringResource(Res.string.save), { onSave(minutes) })
    ) {
        Text(stringResource(Res.string.settings_checklist_alert_desc), color = Color.White.copy(alpha = 0.85f))
        DialogSection(stringResource(Res.string.settings_checklist_alert_after)) {
            EvoRadioGroup(
                options = choices,
                selected = minutes,
                onSelect = { minutes = it },
                optionLabel = { noShowLabel(it) }
            )
        }
    }
}

/**
 * Which Sundays and public holidays the workplace opens on (SH-55): every one (exempt businesses
 * such as cafés), the statutory trading Sundays only (retail), or never.
 */
@Composable
fun SundayPolicyDialog(initial: SundayPolicy, onDismiss: () -> Unit, onSave: (SundayPolicy) -> Unit) {
    var policy by remember { mutableStateOf(initial) }
    EvoDialog(
        title = stringResource(Res.string.settings_sunday),
        icon = Icons.Default.Event,
        onDismiss = onDismiss,
        confirm = DialogAction(stringResource(Res.string.save), { onSave(policy) })
    ) {
        Text(stringResource(Res.string.settings_sunday_desc), color = Color.White.copy(alpha = 0.85f))
        DialogSection(stringResource(Res.string.settings_sunday_policy)) {
            EvoRadioGroup(
                options = SundayPolicy.entries,
                selected = policy,
                onSelect = { policy = it },
                optionLabel = { stringResource(sundayPolicyTitleRes(it)) },
                description = { stringResource(sundayPolicyDescriptionRes(it)) }
            )
        }
    }
}

/** SH-255: the roster visibility row and the dialog's choices (robot tests). */
const val ROSTER_VISIBILITY_ROW_TAG = "settings_roster_visibility_row"
const val ROSTER_VISIBILITY_OPTIONS_TAG = "settings_roster_visibility_options"

/** SH-255: the name of each choice of what employees see in the roster (robots read it too). */
fun rosterVisibilityTitleRes(visibility: RosterVisibility): org.jetbrains.compose.resources.StringResource = when (visibility) {
    RosterVisibility.FULL -> Res.string.settings_roster_visibility_full
    RosterVisibility.WORKING_WITH_ME -> Res.string.settings_roster_visibility_with_me
    RosterVisibility.OWN_ONLY -> Res.string.settings_roster_visibility_own
}

/** SH-255: what each choice means. */
fun rosterVisibilityDescriptionRes(visibility: RosterVisibility): org.jetbrains.compose.resources.StringResource = when (visibility) {
    RosterVisibility.FULL -> Res.string.settings_roster_visibility_full_desc
    RosterVisibility.WORKING_WITH_ME -> Res.string.settings_roster_visibility_with_me_desc
    RosterVisibility.OWN_ONLY -> Res.string.settings_roster_visibility_own_desc
}

@Composable
private fun rosterVisibilityTitle(visibility: RosterVisibility): String = stringResource(rosterVisibilityTitleRes(visibility))

@Composable
private fun rosterVisibilityDescription(visibility: RosterVisibility): String = stringResource(rosterVisibilityDescriptionRes(visibility))

/** SH-226: the weather setting's sources line and its switch (robot tests). */
const val WEATHER_SETTING_SOURCES_TAG = "settings_weather_sources"
const val WEATHER_SETTING_SWITCH_TAG = "settings_weather_switch"
/** SH-257: the "Godziny pracy" dialog's switch. */
const val WORK_HOURS_SETTING_SWITCH_TAG = "settings_work_hours_switch"
/** SH-239: the EVoShift footer's row and its switch. */
const val FOOTER_SETTING_ROW_TAG = "settings_footer_row"
const val FOOTER_SETTING_SWITCH_TAG = "settings_footer_switch"

/** SH-227: the special days' switch, its voivodeship field and the unknown-voivodeship hint (robot tests). */
const val SPECIAL_DAYS_SWITCH_TAG = "settings_special_days_switch"
const val SPECIAL_DAYS_VOIVODESHIP_TAG = "settings_special_days_voivodeship"
const val SPECIAL_DAYS_UNKNOWN_TAG = "settings_special_days_unknown"

/**
 * SH-227: "School breaks and long weekends": on or off (on by default; the events typed in show
 * either way) and the voivodeship for the winter break: from the address, or chosen here.
 */
@Composable
private fun SpecialDaysSettingDialog(
    workplace: com.evoapps.evoshift.domain.model.Workplace,
    onDismiss: () -> Unit,
    onSave: (Boolean, com.evoapps.evoshift.domain.model.Voivodeship?) -> Unit
) {
    var on by remember { mutableStateOf(workplace.settings.specialDaysEnabled) }
    var chosen by remember { mutableStateOf(workplace.settings.voivodeship) }
    val fromAddress = remember(workplace.address) { com.evoapps.evoshift.domain.specialdays.VoivodeshipFinder.fromAddress(workplace.address) }
    val poland = workplace.settings.market == com.evoapps.evoshift.domain.market.Market.POLAND
    EvoDialog(
        title = stringResource(Res.string.settings_special_days_title),
        icon = Icons.Default.Weekend,
        onDismiss = onDismiss,
        confirm = DialogAction(stringResource(Res.string.save), { onSave(on, chosen) })
    ) {
        DialogSection(null) {
            EvoSwitchRow(
                checked = on,
                onCheckedChange = { on = it },
                label = stringResource(Res.string.settings_special_days_switch),
                supporting = stringResource(Res.string.settings_special_days_hint),
                modifier = Modifier.testTag(SPECIAL_DAYS_SWITCH_TAG)
            )
            if (on && poland) {
                val auto = if (fromAddress != null) stringResource(Res.string.settings_special_days_voivodeship_found, fromAddress.polishName)
                else stringResource(Res.string.settings_special_days_voivodeship_auto)
                EvoDropdown(
                    label = stringResource(Res.string.settings_special_days_voivodeship),
                    options = listOf<com.evoapps.evoshift.domain.model.Voivodeship?>(null) + com.evoapps.evoshift.domain.model.Voivodeship.entries,
                    selected = chosen,
                    onSelected = { chosen = it },
                    optionLabel = { it?.polishName ?: auto },
                    placeholder = auto,
                    modifier = Modifier.testTag(SPECIAL_DAYS_VOIVODESHIP_TAG)
                )
                if (chosen == null && fromAddress == null) {
                    Text(stringResource(Res.string.settings_special_days_voivodeship_unknown), style = MaterialTheme.typography.bodySmall)
                }
            }
            Text(stringResource(Res.string.settings_special_days_sources), style = MaterialTheme.typography.bodySmall)
        }
    }
}

/** SH-269: the cards' group settings lines: a workplace's sources, or the group's reach in group mode. */
private fun sectionSources(state: com.evoapps.evoshift.viewmodels.SettingsUiState, onEvent: (SettingsEvent) -> Unit): SectionSources? {
    val canSwitch = { section: com.evoapps.evoshift.domain.model.SettingsSection ->
        state.capabilities.shows(
            when {
                section == com.evoapps.evoshift.domain.model.SettingsSection.STAFF_CHECKS -> Gate.STAFF_RECORDS_EDITING
                section.finances -> Gate.WORKPLACE_FINANCES_EDITING
                else -> Gate.SETTINGS_EDITING
            }
        )
    }
    state.group?.let { group ->
        val total = group.workplaces.size
        return SectionSources(
            sourceOf = { null },
            groupName = group.name,
            canSwitch = { false },
            onSet = { _, _ -> },
            groupCount = { section -> (state.groupFollowing[section]?.size ?: 0) to total }
        )
    }
    val link = state.groupLink?.takeIf { it.isShared } ?: return null
    return SectionSources(
        sourceOf = state::sourceOf,
        groupName = link.groupName,
        canSwitch = canSwitch,
        onSet = { section, source -> onEvent(SettingsEvent.SetSectionSource(section, source)) }
    )
}
